export type Maybe<T> = T | undefined;
export type InputMaybe<T> = T | undefined;
export type Exact<T extends { [key: string]: unknown }> = {
    [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
    [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
    [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
    T extends { [key: string]: unknown },
    K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
    | T
    | {
          [P in keyof T]?: P extends ' $fragmentName' | '__typename'
              ? T[P]
              : never;
      };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
    ID: { input: string; output: string };
    String: { input: string; output: string };
    Boolean: { input: boolean; output: boolean };
    Int: { input: number; output: number };
    Float: { input: number; output: number };
    Date: { input: any; output: any };
};

export type AcceptUserAgreementsInput = {
    kinds: Array<InputMaybe<LegalAgreementKindEnum>>;
};

export type AccountBalanceSummary = {
    __typename?: 'AccountBalanceSummary';
    accountingStatus: AccountStatusEnum;
    balance?: Maybe<Scalars['Float']['output']>;
    currencyCode?: Maybe<Scalars['String']['output']>;
    currencySymbol?: Maybe<Scalars['String']['output']>;
    overduePayments: Array<OverduePayment>;
};

export enum AccountStatusEnum {
    Collection = 'Collection',
    Good = 'Good',
    PoorStanding = 'PoorStanding',
}

export type Agreement = {
    __typename?: 'Agreement';
    kind: LegalAgreementKindEnum;
    requireUpdate?: Maybe<Scalars['Boolean']['output']>;
    version?: Maybe<Scalars['String']['output']>;
};

export type Agreements = {
    __typename?: 'Agreements';
    agreements?: Maybe<Array<Maybe<Agreement>>>;
};

export type AllSubscriptions = {
    __typename?: 'AllSubscriptions';
    subscriptions?: Maybe<Array<Maybe<CurrentSubscription>>>;
};

export type AllowedFeature = {
    __typename?: 'AllowedFeature';
    isAllowed: Scalars['Boolean']['output'];
    unallowedReason?: Maybe<UnallowedReason>;
};

export type AlternateLanguage = {
    __typename?: 'AlternateLanguage';
    id: Scalars['ID']['output'];
    lang: Scalars['String']['output'];
    type: Scalars['String']['output'];
    uid?: Maybe<Scalars['String']['output']>;
};

export type Artist = {
    __typename?: 'Artist';
    artworkUrl?: Maybe<Scalars['String']['output']>;
    coverUrl?: Maybe<Scalars['String']['output']>;
    description?: Maybe<Scalars['String']['output']>;
    guid: Scalars['ID']['output'];
    isExclusive: Scalars['Boolean']['output'];
    name?: Maybe<Scalars['String']['output']>;
    packCount?: Maybe<Scalars['Int']['output']>;
    portraitUrl?: Maybe<Scalars['String']['output']>;
    sampleCount?: Maybe<Scalars['Int']['output']>;
    slug?: Maybe<Scalars['String']['output']>;
};

export type Balance = {
    __typename?: 'Balance';
    balance?: Maybe<Scalars['Int']['output']>;
};

export enum BpmMultiplier {
    Double = 'Double',
    Half = 'Half',
    None = 'None',
}

export type Brandtype = {
    __typename?: 'Brandtype';
    description?: Maybe<Scalars['String']['output']>;
    guid: Scalars['ID']['output'];
    name?: Maybe<Scalars['String']['output']>;
    packCount?: Maybe<Scalars['Int']['output']>;
    sampleCount?: Maybe<Scalars['Int']['output']>;
    slug?: Maybe<Scalars['String']['output']>;
};

export type Classifier = {
    __typename?: 'Classifier';
    code: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    isPackClassifier: Scalars['Boolean']['output'];
    type: ClassifierType;
};

export enum ClassifierType {
    Free = 'Free',
    Genre = 'Genre',
    Instrument = 'Instrument',
    Sfx = 'Sfx',
    Tag = 'Tag',
}

export type Collection = {
    __typename?: 'Collection';
    artworkUrl?: Maybe<Scalars['String']['output']>;
    guid: Scalars['ID']['output'];
    isDownloaded: Scalars['Boolean']['output'];
    isExclusive: Scalars['Boolean']['output'];
    isFavorited: Scalars['Boolean']['output'];
    isFree: Scalars['Boolean']['output'];
    name?: Maybe<Scalars['String']['output']>;
    slug?: Maybe<Scalars['String']['output']>;
    subType: RepackSubType;
    type: PackType;
};

export type ContentGroup = {
    __typename?: 'ContentGroup';
    byline: Scalars['String']['output'];
    contentLists: Array<Maybe<ContentList>>;
    guid: Scalars['ID']['output'];
    target: ContentTarget;
    title: Scalars['String']['output'];
    to?: Maybe<Scalars['String']['output']>;
};

export type ContentList = {
    __typename?: 'ContentList';
    items: Array<Maybe<ContentListItem>>;
    tabName: Scalars['String']['output'];
};

export type ContentListItem = Pack | Repack;

export enum ContentTarget {
    AuthenticatedOnly = 'AuthenticatedOnly',
    GuestAndAuthenticated = 'GuestAndAuthenticated',
    GuestOnly = 'GuestOnly',
}

export type CostPreviewResponse = {
    __typename?: 'CostPreviewResponse';
    credits?: Maybe<Scalars['Int']['output']>;
    remainingCredits?: Maybe<Scalars['Int']['output']>;
    unavailabilityReason?: Maybe<Scalars['String']['output']>;
};

export type CreatorSession = {
    __typename?: 'CreatorSession';
    bpm: Scalars['Int']['output'];
    guid: Scalars['ID']['output'];
    isPublic?: Maybe<Scalars['Boolean']['output']>;
    key: Key;
    name?: Maybe<Scalars['String']['output']>;
    samples: Array<Track>;
    userId?: Maybe<Scalars['ID']['output']>;
    version?: Maybe<Scalars['Int']['output']>;
};

export type CreatorSessionInput = {
    bpm: Scalars['Int']['input'];
    guid?: InputMaybe<Scalars['ID']['input']>;
    isPublic?: InputMaybe<Scalars['Boolean']['input']>;
    key?: InputMaybe<KeyInput>;
    name?: InputMaybe<Scalars['String']['input']>;
    samples?: InputMaybe<Array<InputMaybe<TrackInput>>>;
    version: Scalars['Int']['input'];
};

export type CreditBalancePayloadType = {
    __typename?: 'CreditBalancePayloadType';
    hdwav?: Maybe<Balance>;
    mp3?: Maybe<Balance>;
    sample?: Maybe<Balance>;
    wav?: Maybe<Balance>;
};

export type Currency = {
    __typename?: 'Currency';
    currencyCode: Scalars['String']['output'];
    currencySymbol: Scalars['String']['output'];
};

export type CurrentSubscription = {
    __typename?: 'CurrentSubscription';
    activationDate?: Maybe<Scalars['String']['output']>;
    creationDate: Scalars['String']['output'];
    endDate?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    isTrial: Scalars['Boolean']['output'];
    nextPeriodStartDate?: Maybe<Scalars['String']['output']>;
    plan: PlanFrequencyIdentifier;
    segment?: Maybe<Scalars['String']['output']>;
    serviceOffer: ServiceOfferKind;
    status: SubscriptionStatusEnum;
};

export type CurrentSubscriptionDetails = {
    __typename?: 'CurrentSubscriptionDetails';
    billingCommitment: SubscriptionBillingCommitment;
    code: Scalars['String']['output'];
    creationDate: Scalars['Date']['output'];
    endDate?: Maybe<Scalars['Date']['output']>;
    frequency: SubscriptionFrequency;
    grantedCredits: Array<GrantedCredits>;
    id: Scalars['ID']['output'];
    includedFeatures: PlanIncludedFeatures;
    nextPaymentAmount: Price;
    renewalDate?: Maybe<Scalars['Date']['output']>;
};

export type Descriptor = {
    __typename?: 'Descriptor';
    code?: Maybe<Scalars['String']['output']>;
};

export type Filter = {
    __typename?: 'Filter';
    code: Scalars['String']['output'];
};

export type FilterCategories = {
    __typename?: 'FilterCategories';
    genres?: Maybe<Array<FilterFamily>>;
    instruments?: Maybe<Array<FilterFamily>>;
    sampleTypes?: Maybe<Array<Filter>>;
    sfxs?: Maybe<Array<FilterFamily>>;
    tags?: Maybe<Array<FilterWithLabel>>;
    tagsCategories?: Maybe<Array<TagsCategory>>;
};

export type FilterFamily = {
    __typename?: 'FilterFamily';
    code: Scalars['String']['output'];
    subFilters?: Maybe<Array<Filter>>;
};

export type FilterMeta = {
    __typename?: 'FilterMeta';
    name?: Maybe<Scalars['String']['output']>;
    value?: Maybe<Scalars['Int']['output']>;
};

export type FilterWithLabel = {
    __typename?: 'FilterWithLabel';
    category: Scalars['String']['output'];
    code: Scalars['String']['output'];
    label: Scalars['String']['output'];
};

export type Filters = {
    __typename?: 'Filters';
    descriptorFilters?: Maybe<Array<Maybe<FilterMeta>>>;
    genreFilters?: Maybe<Array<Maybe<FilterMeta>>>;
    instrumentFilters?: Maybe<Array<Maybe<FilterMeta>>>;
    sampleTypeFilters?: Maybe<Array<Maybe<FilterMeta>>>;
    sfxFilters?: Maybe<Array<Maybe<FilterMeta>>>;
    tagFilters?: Maybe<Array<Maybe<FilterMeta>>>;
};

export type Genre = {
    __typename?: 'Genre';
    code?: Maybe<Scalars['String']['output']>;
    subGenres?: Maybe<Array<Maybe<SubItems>>>;
};

export type GenreInput = {
    code?: InputMaybe<Scalars['String']['input']>;
    subGenres?: InputMaybe<Array<InputMaybe<GenreInput>>>;
};

export type GrantedCredits = {
    __typename?: 'GrantedCredits';
    isUnlimited: Scalars['Boolean']['output'];
    quantity: Scalars['Int']['output'];
};

export type HeroBanner = {
    __typename?: 'HeroBanner';
    byline?: Maybe<Scalars['String']['output']>;
    contentType: HeroBannerContentType;
    customArtworkUrl?: Maybe<Scalars['String']['output']>;
    customDemoUrl?: Maybe<Scalars['String']['output']>;
    customTags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    description?: Maybe<Scalars['String']['output']>;
    entity?: Maybe<HeroBannerEntityType>;
    genres?: Maybe<Array<Maybe<Genre>>>;
    guid: Scalars['String']['output'];
    instruments?: Maybe<Array<Maybe<Instrument>>>;
    labelPacks?: Maybe<Array<Maybe<Pack>>>;
    title?: Maybe<Scalars['String']['output']>;
};

export enum HeroBannerContentType {
    Collection = 'Collection',
    Custom = 'Custom',
    Label = 'Label',
    Pack = 'Pack',
}

export type HeroBannerEntityType = Label | Pack | Repack;

export enum HomePageEnum {
    Chromatic = 'Chromatic',
    Dashboard = 'Dashboard',
    Distribution = 'Distribution',
    Mastering = 'Mastering',
    Network = 'Network',
    Plugins = 'Plugins',
    Projects = 'Projects',
    Samples = 'Samples',
    Sessions = 'Sessions',
}

export type Instrument = {
    __typename?: 'Instrument';
    code?: Maybe<Scalars['String']['output']>;
    isFamily?: Maybe<Scalars['Boolean']['output']>;
    subInstruments?: Maybe<Array<Maybe<SubItems>>>;
};

export type InstrumentInput = {
    code?: InputMaybe<Scalars['String']['input']>;
    isFamily?: InputMaybe<Scalars['Boolean']['input']>;
    subInstruments?: InputMaybe<Array<InputMaybe<InstrumentInput>>>;
};

export enum Interval {
    Monthly = 'Monthly',
    Yearly = 'Yearly',
}

export type Key = {
    __typename?: 'Key';
    quality: KeyQuality;
    root: KeyRootApi;
    sign: KeySign;
};

export type KeyInput = {
    quality?: InputMaybe<KeyQuality>;
    root?: InputMaybe<KeyRootApi>;
    sign?: InputMaybe<KeySign>;
};

export enum KeyQuality {
    Major = 'major',
    Minor = 'minor',
}

export enum KeyRootApi {
    A = 'A',
    ASharpBFlat = 'ASharpBFlat',
    B = 'B',
    C = 'C',
    CSharpDFlat = 'CSharpDFlat',
    D = 'D',
    DSharpEFlat = 'DSharpEFlat',
    E = 'E',
    F = 'F',
    FSharpGFlat = 'FSharpGFlat',
    G = 'G',
    GSharpAFlat = 'GSharpAFlat',
}

export enum KeySign {
    Flat = 'Flat',
    Sharp = 'Sharp',
}

export type Label = {
    __typename?: 'Label';
    artworkUrl?: Maybe<Scalars['String']['output']>;
    coverUrl?: Maybe<Scalars['String']['output']>;
    description?: Maybe<Scalars['String']['output']>;
    guid: Scalars['ID']['output'];
    isExclusive: Scalars['Boolean']['output'];
    name?: Maybe<Scalars['String']['output']>;
    packCount?: Maybe<Scalars['Int']['output']>;
    sampleCount?: Maybe<Scalars['Int']['output']>;
    slug?: Maybe<Scalars['String']['output']>;
};

export type LabelsChart = {
    __typename?: 'LabelsChart';
    items: Array<Maybe<LabelsChartItem>>;
};

export type LabelsChartItem = {
    __typename?: 'LabelsChartItem';
    artistName?: Maybe<Scalars['String']['output']>;
    artworkUrl: Scalars['String']['output'];
    currentRank: Scalars['Int']['output'];
    guid: Scalars['ID']['output'];
    isNew: Scalars['Boolean']['output'];
    lastRank?: Maybe<Scalars['Int']['output']>;
    name: Scalars['String']['output'];
    slug: Scalars['String']['output'];
    subItemsCount?: Maybe<Scalars['Int']['output']>;
};

export enum LegalAgreementKindEnum {
    PrivacyPolicy = 'PrivacyPolicy',
    TermsOfService = 'TermsOfService',
}

export enum Locale {
    De = 'de',
    En = 'en',
    Es = 'es',
    Fr = 'fr',
    It = 'it',
    Ja = 'ja',
    Pt = 'pt',
}

export type MerchZone = {
    __typename?: 'MerchZone';
    contentGroups: Array<ContentGroup>;
};

export type MetaPage = {
    __typename?: 'MetaPage';
    filters?: Maybe<Filters>;
    totalPackRecords?: Maybe<Scalars['Int']['output']>;
    totalRecords?: Maybe<Scalars['Int']['output']>;
    totalRepackRecords?: Maybe<Scalars['Int']['output']>;
    totalSampleRecords?: Maybe<Scalars['Int']['output']>;
};

export enum MusicGenre {
    Acoustic = 'Acoustic',
    Afrobeat = 'Afrobeat',
    Americana = 'Americana',
    Blues = 'Blues',
    Chill = 'Chill',
    Choral = 'Choral',
    Classical = 'Classical',
    Country = 'Country',
    Dubstep = 'Dubstep',
    Edm = 'Edm',
    ElectricPop = 'Electric_pop',
    Electronic = 'Electronic',
    Folk = 'Folk',
    Funk = 'Funk',
    Gospel = 'Gospel',
    HeavyMetal = 'Heavy_metal',
    HeavyRock = 'Heavy_rock',
    HipHop = 'Hip_hop',
    House = 'House',
    IndiePop = 'Indie_pop',
    Jazz = 'Jazz',
    Latin = 'Latin',
    Pop = 'Pop',
    PopRock = 'Pop_rock',
    Reggae = 'Reggae',
    Reggaeton = 'Reggaeton',
    Rnb = 'Rnb',
    Rock = 'Rock',
    SingerSongwriter = 'Singer_songwriter',
    SoftPop = 'Soft_pop',
    Soul = 'Soul',
    Soundtrack = 'Soundtrack',
    Techno = 'Techno',
    Trance = 'Trance',
    Trap = 'Trap',
    Tropical = 'Tropical',
    World = 'World',
}

export type Mutation = {
    __typename?: 'Mutation';
    acceptUserAgreements?: Maybe<Scalars['Boolean']['output']>;
    activateTrialSubscription: SubscriptionsAndAllowedFeatures;
    addSamplesToUserCollection?: Maybe<UserCollection>;
    createUserCollection?: Maybe<UserCollection>;
    createUserRecentSearch?: Maybe<Scalars['String']['output']>;
    deleteUserCollection?: Maybe<Scalars['String']['output']>;
    deleteUserRecentSearch?: Maybe<Scalars['String']['output']>;
    editUserCollection?: Maybe<Scalars['String']['output']>;
    putMilestones: Array<Scalars['String']['output']>;
    removeSamplesFromUserCollection?: Maybe<UserCollection>;
    storeCreatorSession?: Maybe<CreatorSession>;
    updatePackFavoritedState?: Maybe<Pack>;
    updateRepackFavoritedState?: Maybe<Repack>;
    updateSampleFavoritedState?: Maybe<Sample>;
};

export type MutationAcceptUserAgreementsArgs = {
    agreements: AcceptUserAgreementsInput;
};

export type MutationAddSamplesToUserCollectionArgs = {
    collectionGuid?: InputMaybe<Scalars['ID']['input']>;
    sampleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type MutationCreateUserCollectionArgs = {
    name?: InputMaybe<Scalars['String']['input']>;
    sampleCount?: InputMaybe<Scalars['Int']['input']>;
};

export type MutationCreateUserRecentSearchArgs = {
    filterSlug: Scalars['String']['input'];
    filterType: UserSearchFilter;
};

export type MutationDeleteUserCollectionArgs = {
    collectionGuid?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationDeleteUserRecentSearchArgs = {
    filterSlug: Scalars['String']['input'];
    filterType: UserSearchFilter;
};

export type MutationEditUserCollectionArgs = {
    collectionGuid?: InputMaybe<Scalars['ID']['input']>;
    name?: InputMaybe<Scalars['String']['input']>;
};

export type MutationPutMilestonesArgs = {
    milestones: Array<Scalars['String']['input']>;
};

export type MutationRemoveSamplesFromUserCollectionArgs = {
    collectionGuid?: InputMaybe<Scalars['ID']['input']>;
    sampleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type MutationStoreCreatorSessionArgs = {
    session?: InputMaybe<CreatorSessionInput>;
};

export type MutationUpdatePackFavoritedStateArgs = {
    pack: PackFavoritedInput;
};

export type MutationUpdateRepackFavoritedStateArgs = {
    repack: RepackFavoritedInput;
};

export type MutationUpdateSampleFavoritedStateArgs = {
    sample: SampleFavoritedInput;
};

export type NextPage = {
    __typename?: 'NextPage';
    skip?: Maybe<Scalars['Int']['output']>;
};

export enum OccupationEnum {
    AR = 'A_R',
    Agent = 'Agent',
    Artist = 'Artist',
    ArtistManager = 'Artist_manager',
    Bassist = 'Bassist',
    Beatmaker = 'Beatmaker',
    Blogger = 'Blogger',
    Composer = 'Composer',
    Copywriter = 'Copywriter',
    Dj = 'DJ',
    Designer = 'Designer',
    Drummer = 'Drummer',
    Educator = 'Educator',
    Engineer = 'Engineer',
    EventProgrammer = 'Event_programmer',
    GearManufacturer = 'Gear_manufacturer',
    GraphicDesigner = 'Graphic_designer',
    Guitarist = 'Guitarist',
    Influencer = 'Influencer',
    Instrumentalist = 'Instrumentalist',
    Journalist = 'Journalist',
    Keyboardist = 'Keyboardist',
    LabelOwner = 'Label_owner',
    Lyricist = 'Lyricist',
    MediaFigure = 'Media_figure',
    Moderator = 'Moderator',
    MultiInstrumentalist = 'Multi_instrumentalist',
    MusicDirector = 'Music_director',
    Musician = 'Musician',
    Photographer = 'Photographer',
    Pianist = 'Pianist',
    PodcastHost = 'Podcast_host',
    Producer = 'Producer',
    Promoter = 'Promoter',
    Publicist = 'Publicist',
    Publisher = 'Publisher',
    RadioHost = 'Radio_host',
    Singer = 'Singer',
    Songwriter = 'Songwriter',
    SoundDesign = 'Sound_design',
    StudioOwner = 'Studio_owner',
    Videographer = 'Videographer',
    Vlogger = 'Vlogger',
    WebDesigner = 'Web_designer',
    YouTuber = 'YouTuber',
}

export type OverduePayment = {
    __typename?: 'OverduePayment';
    serviceOffer: ServiceOfferKind;
};

export type Pack = {
    __typename?: 'Pack';
    artist?: Maybe<Artist>;
    artworkUrl?: Maybe<Scalars['String']['output']>;
    backgroundColor?: Maybe<Scalars['String']['output']>;
    creatorSession?: Maybe<Scalars['ID']['output']>;
    description?: Maybe<Scalars['String']['output']>;
    foregroundColor?: Maybe<Scalars['String']['output']>;
    genres?: Maybe<Array<Maybe<Genre>>>;
    guid: Scalars['ID']['output'];
    isDownloaded?: Maybe<Scalars['Boolean']['output']>;
    isExclusive: Scalars['Boolean']['output'];
    isFavorited?: Maybe<Scalars['Boolean']['output']>;
    isFree: Scalars['Boolean']['output'];
    label?: Maybe<Label>;
    mainGenre?: Maybe<Genre>;
    name?: Maybe<Scalars['String']['output']>;
    packState: PackState;
    premiumCodes?: Maybe<Array<Maybe<PremiumCodes>>>;
    sampleCount?: Maybe<Scalars['Int']['output']>;
    sfxs?: Maybe<Array<Maybe<Sfx>>>;
    slug?: Maybe<Scalars['String']['output']>;
    type: PackType;
};

export type PackFavoritedInput = {
    guid: Scalars['ID']['input'];
    isFavorited?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PackState {
    Draft = 'Draft',
    PublicationFailed = 'PublicationFailed',
    Published = 'Published',
    Publishing = 'Publishing',
    TakenDown = 'TakenDown',
}

export enum PackType {
    Pack = 'Pack',
    Repack = 'Repack',
}

export type PackagesMeta = {
    __typename?: 'PackagesMeta';
    url?: Maybe<Scalars['String']['output']>;
    version?: Maybe<Scalars['String']['output']>;
};

export type PacksChart = {
    __typename?: 'PacksChart';
    items: Array<Maybe<PacksChartItem>>;
};

export type PacksChartItem = {
    __typename?: 'PacksChartItem';
    artistName?: Maybe<Scalars['String']['output']>;
    artworkUrl: Scalars['String']['output'];
    currentRank: Scalars['Int']['output'];
    guid: Scalars['ID']['output'];
    isNew: Scalars['Boolean']['output'];
    lastRank?: Maybe<Scalars['Int']['output']>;
    name: Scalars['String']['output'];
    slug: Scalars['String']['output'];
    subItemsCount?: Maybe<Scalars['Int']['output']>;
};

export type PacksOrRepacks = Pack | Repack;

export type PaginatedArtists = {
    __typename?: 'PaginatedArtists';
    data?: Maybe<Array<Maybe<Artist>>>;
    meta?: Maybe<MetaPage>;
    next?: Maybe<NextPage>;
};

export type PaginatedLabels = {
    __typename?: 'PaginatedLabels';
    data?: Maybe<Array<Maybe<Label>>>;
    meta?: Maybe<MetaPage>;
    next?: Maybe<NextPage>;
};

export type PaginatedPacks = {
    __typename?: 'PaginatedPacks';
    data?: Maybe<Array<Maybe<Pack>>>;
    meta?: Maybe<MetaPage>;
    next?: Maybe<NextPage>;
};

export type PaginatedPacksOrRepacks = {
    __typename?: 'PaginatedPacksOrRepacks';
    data?: Maybe<Array<Maybe<PacksOrRepacks>>>;
    meta?: Maybe<MetaPage>;
    next?: Maybe<NextPage>;
};

export type PaginatedRepacks = {
    __typename?: 'PaginatedRepacks';
    data?: Maybe<Array<Maybe<Repack>>>;
    meta?: Maybe<MetaPage>;
    next?: Maybe<NextPage>;
};

export type PaginatedSamples = {
    __typename?: 'PaginatedSamples';
    data?: Maybe<Array<Maybe<Sample>>>;
    meta?: Maybe<MetaPage>;
    next?: Maybe<NextPage>;
};

export type PaginatedUserCollections = {
    __typename?: 'PaginatedUserCollections';
    data?: Maybe<Array<Maybe<UserCollection>>>;
    meta?: Maybe<MetaPage>;
    next?: Maybe<NextPage>;
};

export type PlanFrequencyIdentifier = {
    __typename?: 'PlanFrequencyIdentifier';
    code: Scalars['String']['output'];
    frequency?: Maybe<Interval>;
};

export type PlanIncludedFeatures = {
    __typename?: 'PlanIncludedFeatures';
    id: Scalars['ID']['output'];
    samples: SamplesIncludedFeature;
};

export type PluginPackages = {
    __typename?: 'PluginPackages';
    macOS?: Maybe<PackagesMeta>;
    windows?: Maybe<PackagesMeta>;
};

export enum PremiumCodes {
    LandrStudio = 'landr_studio',
    SamplesPro = 'samples_pro',
    SamplesTier1 = 'samples_tier1',
    SamplesTier2 = 'samples_tier2',
    SamplesTier3 = 'samples_tier3',
}

export type Price = {
    __typename?: 'Price';
    currency: Currency;
    value?: Maybe<Scalars['Float']['output']>;
};

export type PrismicBackgroundImage = {
    __typename?: 'PrismicBackgroundImage';
    alt?: Maybe<Scalars['String']['output']>;
    copyright?: Maybe<Scalars['String']['output']>;
    dimensions: PrismicImageDimensions;
    regular: PrismicImage;
    url: Scalars['String']['output'];
};

export type PrismicBanner = {
    __typename?: 'PrismicBanner';
    first_publication_date: Scalars['Date']['output'];
    id: Scalars['ID']['output'];
    isBroken?: Maybe<Scalars['Boolean']['output']>;
    lang: Scalars['String']['output'];
    last_publication_date: Scalars['Date']['output'];
    link_type: Scalars['String']['output'];
    slug: Scalars['String']['output'];
    tags: Array<Maybe<Scalars['String']['output']>>;
    type: Scalars['String']['output'];
};

export type PrismicBannerData =
    | PrismicSampleAuthBannerData
    | PrismicSampleBannerData
    | PrismicSampleBannerGroupData;

export type PrismicDocument = {
    __typename?: 'PrismicDocument';
    alternate_languages: Array<Maybe<AlternateLanguage>>;
    data: PrismicBannerData;
    first_publication_date: Scalars['String']['output'];
    href: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    lang: Scalars['String']['output'];
    last_publication_date: Scalars['String']['output'];
    slugs: Array<Maybe<Scalars['String']['output']>>;
    tags: Array<Maybe<Scalars['String']['output']>>;
    type: Scalars['String']['output'];
    uid?: Maybe<Scalars['String']['output']>;
};

export type PrismicImage = {
    __typename?: 'PrismicImage';
    alt?: Maybe<Scalars['String']['output']>;
    copyright?: Maybe<Scalars['String']['output']>;
    dimensions: PrismicImageDimensions;
    url: Scalars['String']['output'];
};

export type PrismicImageDimensions = {
    __typename?: 'PrismicImageDimensions';
    height: Scalars['Int']['output'];
    width: Scalars['Int']['output'];
};

export type PrismicSampleAuthBannerCtaLink = {
    __typename?: 'PrismicSampleAuthBannerCtaLink';
    authenticated_cta_link: Array<PrismicTextField>;
    guest_cta_link: Array<PrismicTextField>;
};

export type PrismicSampleAuthBannerCtaText = {
    __typename?: 'PrismicSampleAuthBannerCtaText';
    authenticated_cta_text: Array<PrismicTextField>;
    guest_cta_text: Array<PrismicTextField>;
};

export type PrismicSampleAuthBannerData = {
    __typename?: 'PrismicSampleAuthBannerData';
    background_image: PrismicBackgroundImage;
    banner_title: Array<PrismicTextField>;
    cta_link: Array<PrismicSampleAuthBannerCtaLink>;
    cta_text: Array<PrismicSampleAuthBannerCtaText>;
    description: Array<PrismicSampleAuthBannerDescription>;
    title: Array<PrismicSampleAuthBannerTitle>;
};

export type PrismicSampleAuthBannerDescription = {
    __typename?: 'PrismicSampleAuthBannerDescription';
    authenticated_description: Array<PrismicTextField>;
    guest_description: Array<PrismicTextField>;
};

export type PrismicSampleAuthBannerTitle = {
    __typename?: 'PrismicSampleAuthBannerTitle';
    authenticated_title: Array<PrismicTextField>;
    guest_title: Array<PrismicTextField>;
};

export type PrismicSampleBannerData = {
    __typename?: 'PrismicSampleBannerData';
    background_color?: Maybe<Scalars['String']['output']>;
    background_image: PrismicBackgroundImage;
    banner_title: Array<PrismicTextField>;
    cta_path: Array<PrismicTextField>;
    cta_text: Array<PrismicTextField>;
    description: Array<PrismicTextField>;
    title: Array<PrismicTextField>;
};

export type PrismicSampleBannerGroupData = {
    __typename?: 'PrismicSampleBannerGroupData';
    banner_a: PrismicBanner;
    banner_b: PrismicBanner;
    banner_c: PrismicBanner;
    banner_d: PrismicBanner;
    banner_e: PrismicBanner;
    title: Array<PrismicTextField>;
};

export type PrismicTextField = {
    __typename?: 'PrismicTextField';
    spans: Array<Maybe<Scalars['String']['output']>>;
    text: Scalars['String']['output'];
    type: Scalars['String']['output'];
};

export enum ProviderType {
    Aggregator = 'AGGREGATOR',
    Artist = 'ARTIST',
    Label = 'LABEL',
}

export type PurchasableCreatorSample = {
    gainDb?: InputMaybe<Scalars['Float']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    semitoneShift?: InputMaybe<Scalars['Float']['input']>;
    timeFactor?: InputMaybe<Scalars['Float']['input']>;
};

export type PurchasableCreatorSession = {
    async?: InputMaybe<Scalars['Boolean']['input']>;
    samples?: InputMaybe<Array<InputMaybe<PurchasableCreatorSample>>>;
    targetBpm?: InputMaybe<Scalars['Int']['input']>;
    targetKey?: InputMaybe<Scalars['String']['input']>;
    targetKeyQuality?: InputMaybe<Scalars['String']['input']>;
    targetKeyRoot?: InputMaybe<Scalars['String']['input']>;
};

export type PurchaseResponse = {
    __typename?: 'PurchaseResponse';
    url?: Maybe<Scalars['String']['output']>;
};

export type Query = {
    __typename?: 'Query';
    accountBalanceSummary?: Maybe<AccountBalanceSummary>;
    artistBySlug?: Maybe<Artist>;
    bannerGroup: Array<PrismicDocument>;
    brandtypeBySlug?: Maybe<Brandtype>;
    chartsTopLabels?: Maybe<LabelsChart>;
    chartsTopLandrPacks?: Maybe<RepacksChart>;
    chartsTopPacks?: Maybe<PacksChart>;
    collectionCostPreview?: Maybe<CostPreviewResponse>;
    collectionPurchase?: Maybe<PurchaseResponse>;
    contentGroup?: Maybe<ContentGroup>;
    creatorMixdownPurchase?: Maybe<PurchaseResponse>;
    creatorSamplesCostPreview?: Maybe<CostPreviewResponse>;
    creatorSamplesPurchase?: Maybe<PurchaseResponse>;
    creatorSessionById?: Maybe<CreatorSession>;
    filters?: Maybe<FilterCategories>;
    getUserRecentSearch: UserRecentSearches;
    heroBanners?: Maybe<Array<Maybe<HeroBanner>>>;
    labelBySlug?: Maybe<Label>;
    merchZone?: Maybe<MerchZone>;
    milestones: Array<Scalars['String']['output']>;
    pack?: Maybe<Pack>;
    packCostPreview?: Maybe<CostPreviewResponse>;
    packPurchase?: Maybe<PurchaseResponse>;
    packStream?: Maybe<StreamUrl>;
    paginatedArtistPacks?: Maybe<PaginatedPacks>;
    paginatedArtistSamples?: Maybe<PaginatedSamples>;
    paginatedArtists?: Maybe<PaginatedArtists>;
    paginatedBrandtypeRepacks?: Maybe<PaginatedRepacks>;
    paginatedBrandtypeSamples?: Maybe<PaginatedSamples>;
    paginatedDownloadedPacksAndRepacksV2?: Maybe<PaginatedPacksOrRepacks>;
    paginatedDownloadedSamples?: Maybe<PaginatedSamples>;
    paginatedFavoritedPacksAndRepacksV2?: Maybe<PaginatedPacksOrRepacks>;
    paginatedFavoritedSamples?: Maybe<PaginatedSamples>;
    paginatedLabelPacks?: Maybe<PaginatedPacks>;
    paginatedLabelSamples?: Maybe<PaginatedSamples>;
    paginatedLabels?: Maybe<PaginatedLabels>;
    paginatedPackSamples?: Maybe<PaginatedSamples>;
    paginatedPacks?: Maybe<PaginatedPacks>;
    paginatedPacksAndRepacks?: Maybe<PaginatedPacksOrRepacks>;
    paginatedRecommendedSamples?: Maybe<PaginatedSamples>;
    paginatedRepackSamples?: Maybe<PaginatedSamples>;
    paginatedRepacks?: Maybe<PaginatedRepacks>;
    paginatedSamples?: Maybe<PaginatedSamples>;
    paginatedUserCollectionSamples?: Maybe<PaginatedSamples>;
    paginatedUserCollections?: Maybe<PaginatedUserCollections>;
    pluginPackages?: Maybe<PluginPackages>;
    repack?: Maybe<Repack>;
    repackCostPreview?: Maybe<CostPreviewResponse>;
    repackPurchase?: Maybe<PurchaseResponse>;
    repackStream?: Maybe<StreamUrl>;
    sample?: Maybe<Sample>;
    sampleStream?: Maybe<StreamUrl>;
    sampleWaveform?: Maybe<Waveform>;
    samplesCostPreview?: Maybe<CostPreviewResponse>;
    samplesPurchase?: Maybe<PurchaseResponse>;
    seoByPath?: Maybe<Seo>;
    similarPacks?: Maybe<PaginatedPacks>;
    subscriptionsAndAllowedFeatures?: Maybe<SubscriptionsAndAllowedFeatures>;
    userAgreements?: Maybe<Agreements>;
    userCollection?: Maybe<UserCollection>;
    userCollections?: Maybe<Array<Maybe<UserCollection>>>;
    userCollectionsFeed?: Maybe<UserCollectionsFeed>;
    userCredits?: Maybe<UserCredits>;
    userProfile?: Maybe<User>;
};

export type QueryArtistBySlugArgs = {
    slug?: InputMaybe<Scalars['String']['input']>;
};

export type QueryBannerGroupArgs = {
    locale?: InputMaybe<Locale>;
};

export type QueryBrandtypeBySlugArgs = {
    slug?: InputMaybe<Scalars['String']['input']>;
};

export type QueryCollectionCostPreviewArgs = {
    guid?: InputMaybe<Scalars['String']['input']>;
};

export type QueryCollectionPurchaseArgs = {
    guid?: InputMaybe<Scalars['String']['input']>;
    interactionSource?: InputMaybe<Scalars['String']['input']>;
};

export type QueryContentGroupArgs = {
    guid: Scalars['ID']['input'];
};

export type QueryCreatorMixdownPurchaseArgs = {
    interactionSource?: InputMaybe<Scalars['String']['input']>;
    purchasableItem: PurchasableCreatorSession;
};

export type QueryCreatorSamplesCostPreviewArgs = {
    guid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryCreatorSamplesPurchaseArgs = {
    interactionSource?: InputMaybe<Scalars['String']['input']>;
    purchasableItem: PurchasableCreatorSession;
};

export type QueryCreatorSessionByIdArgs = {
    sessionId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryLabelBySlugArgs = {
    slug?: InputMaybe<Scalars['String']['input']>;
};

export type QueryMerchZoneArgs = {
    slug: Scalars['ID']['input'];
};

export type QueryPackArgs = {
    packSlugOrGuid: Scalars['ID']['input'];
};

export type QueryPackCostPreviewArgs = {
    guid?: InputMaybe<Scalars['String']['input']>;
};

export type QueryPackPurchaseArgs = {
    guid?: InputMaybe<Scalars['String']['input']>;
    interactionSource?: InputMaybe<Scalars['String']['input']>;
};

export type QueryPackStreamArgs = {
    packGuid: Scalars['ID']['input'];
};

export type QueryPaginatedArtistPacksArgs = {
    artistGuid?: InputMaybe<Scalars['ID']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    query?: InputMaybe<Scalars['String']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryPaginatedArtistSamplesArgs = {
    artistGuid?: InputMaybe<Scalars['ID']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    query?: InputMaybe<Scalars['String']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryPaginatedArtistsArgs = {
    offset?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    query?: InputMaybe<Scalars['String']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryPaginatedBrandtypeRepacksArgs = {
    brandtypeGuid?: InputMaybe<Scalars['ID']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    query?: InputMaybe<Scalars['String']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryPaginatedBrandtypeSamplesArgs = {
    brandtypeGuid?: InputMaybe<Scalars['ID']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    query?: InputMaybe<Scalars['String']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryPaginatedDownloadedPacksAndRepacksV2Args = {
    offset?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    query?: InputMaybe<Scalars['String']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryPaginatedDownloadedSamplesArgs = {
    offset?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    query?: InputMaybe<Scalars['String']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryPaginatedFavoritedPacksAndRepacksV2Args = {
    offset?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    query?: InputMaybe<Scalars['String']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryPaginatedFavoritedSamplesArgs = {
    offset?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    query?: InputMaybe<Scalars['String']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryPaginatedLabelPacksArgs = {
    labelGuid?: InputMaybe<Scalars['ID']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    query?: InputMaybe<Scalars['String']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryPaginatedLabelSamplesArgs = {
    labelGuid?: InputMaybe<Scalars['ID']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    query?: InputMaybe<Scalars['String']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryPaginatedLabelsArgs = {
    offset?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    query?: InputMaybe<Scalars['String']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryPaginatedPackSamplesArgs = {
    offset?: InputMaybe<Scalars['Int']['input']>;
    packGuid?: InputMaybe<Scalars['ID']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    query?: InputMaybe<Scalars['String']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryPaginatedPacksArgs = {
    offset?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    query?: InputMaybe<Scalars['String']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryPaginatedPacksAndRepacksArgs = {
    offset?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    query?: InputMaybe<Scalars['String']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryPaginatedRecommendedSamplesArgs = {
    offset?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    query?: InputMaybe<Scalars['String']['input']>;
    sampleGuid: Scalars['ID']['input'];
    take?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryPaginatedRepackSamplesArgs = {
    offset?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    query?: InputMaybe<Scalars['String']['input']>;
    repackGuid?: InputMaybe<Scalars['ID']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryPaginatedRepacksArgs = {
    offset?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    query?: InputMaybe<Scalars['String']['input']>;
    subType?: InputMaybe<RepackSubType>;
    take?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryPaginatedSamplesArgs = {
    offset?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    query?: InputMaybe<Scalars['String']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryPaginatedUserCollectionSamplesArgs = {
    collectionGuid?: InputMaybe<Scalars['ID']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    query?: InputMaybe<Scalars['String']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryPaginatedUserCollectionsArgs = {
    offset?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    query?: InputMaybe<Scalars['String']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryRepackArgs = {
    repackSlugOrGuid: Scalars['ID']['input'];
};

export type QueryRepackCostPreviewArgs = {
    guid?: InputMaybe<Scalars['String']['input']>;
};

export type QueryRepackPurchaseArgs = {
    guid?: InputMaybe<Scalars['String']['input']>;
    interactionSource?: InputMaybe<Scalars['String']['input']>;
};

export type QueryRepackStreamArgs = {
    repackGuid: Scalars['ID']['input'];
};

export type QuerySampleArgs = {
    sampleGuid: Scalars['ID']['input'];
};

export type QuerySampleStreamArgs = {
    sampleGuid: Scalars['ID']['input'];
};

export type QuerySampleWaveformArgs = {
    sampleGuid: Scalars['ID']['input'];
    waveformUrl: Scalars['String']['input'];
};

export type QuerySamplesCostPreviewArgs = {
    guid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QuerySamplesPurchaseArgs = {
    guid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    interactionSource?: InputMaybe<Scalars['String']['input']>;
};

export type QuerySeoByPathArgs = {
    pathname?: InputMaybe<Scalars['ID']['input']>;
};

export type QuerySimilarPacksArgs = {
    packSlugOrGuid: Scalars['ID']['input'];
};

export type QueryUserCollectionArgs = {
    collectionGuid?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryUserCollectionsArgs = {
    offset?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    query?: InputMaybe<Scalars['String']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryUserCollectionsFeedArgs = {
    offset?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    query?: InputMaybe<Scalars['String']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
};

export type Repack = {
    __typename?: 'Repack';
    artist?: Maybe<Artist>;
    artworkUrl?: Maybe<Scalars['String']['output']>;
    backgroundColor?: Maybe<Scalars['String']['output']>;
    brandtype?: Maybe<Brandtype>;
    creatorSession?: Maybe<Scalars['ID']['output']>;
    description?: Maybe<Scalars['String']['output']>;
    foregroundColor?: Maybe<Scalars['String']['output']>;
    genres?: Maybe<Array<Maybe<Genre>>>;
    guid: Scalars['ID']['output'];
    instrument?: Maybe<Instrument>;
    isDownloaded?: Maybe<Scalars['Boolean']['output']>;
    isExclusive: Scalars['Boolean']['output'];
    isFavorited?: Maybe<Scalars['Boolean']['output']>;
    isFree: Scalars['Boolean']['output'];
    label?: Maybe<Label>;
    mainGenre?: Maybe<Genre>;
    name?: Maybe<Scalars['String']['output']>;
    packState: PackState;
    premiumCodes?: Maybe<Array<Maybe<PremiumCodes>>>;
    sampleCount?: Maybe<Scalars['Int']['output']>;
    sfxs?: Maybe<Array<Maybe<Sfx>>>;
    slug?: Maybe<Scalars['String']['output']>;
    subType?: Maybe<RepackSubType>;
    type: PackType;
};

export type RepackFavoritedInput = {
    guid: Scalars['ID']['input'];
    isFavorited: Scalars['Boolean']['input'];
};

export enum RepackSubType {
    Chart = 'Chart',
    Collection = 'Collection',
    Creator = 'Creator',
}

export type RepacksChart = {
    __typename?: 'RepacksChart';
    items: Array<Maybe<PacksChartItem>>;
};

export type RepacksChartItem = {
    __typename?: 'RepacksChartItem';
    artistName?: Maybe<Scalars['String']['output']>;
    artworkUrl: Scalars['String']['output'];
    currentRank: Scalars['Int']['output'];
    guid: Scalars['ID']['output'];
    isNew: Scalars['Boolean']['output'];
    lastRank?: Maybe<Scalars['Int']['output']>;
    name: Scalars['String']['output'];
    slug: Scalars['String']['output'];
    subItemsCount: Scalars['Int']['output'];
};

export type Sample = {
    __typename?: 'Sample';
    bpm?: Maybe<Scalars['Int']['output']>;
    classifiers: Array<Classifier>;
    credits?: Maybe<Scalars['Int']['output']>;
    duration?: Maybe<Scalars['Float']['output']>;
    guid: Scalars['ID']['output'];
    /** @deprecated Use classifiers.instruments instead */
    instruments?: Maybe<Array<Maybe<Instrument>>>;
    isDownloaded: Scalars['Boolean']['output'];
    isFavorited: Scalars['Boolean']['output'];
    isRecommendationFiller?: Maybe<Scalars['Boolean']['output']>;
    key?: Maybe<SampleKey>;
    name?: Maybe<Scalars['String']['output']>;
    pack?: Maybe<Pack>;
    sampleState: SampleState;
    sampleType?: Maybe<SampleType>;
    /** @deprecated Use classifiers.sfxs instead */
    sfxs?: Maybe<Array<Maybe<Sfx>>>;
    /** @deprecated Use classifiers.tags instead */
    tags?: Maybe<Array<Maybe<Tag>>>;
    waveformUrl?: Maybe<Scalars['String']['output']>;
};

export type SampleFavoritedInput = {
    guid: Scalars['ID']['input'];
    isFavorited?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SampleKey = {
    __typename?: 'SampleKey';
    code?: Maybe<Scalars['String']['output']>;
    quality?: Maybe<KeyQuality>;
    root?: Maybe<KeyRootApi>;
    sanitizedCode?: Maybe<Scalars['String']['output']>;
};

export type SampleKeyInput = {
    code?: InputMaybe<Scalars['String']['input']>;
    quality?: InputMaybe<KeyQuality>;
    root?: InputMaybe<KeyRootApi>;
    sanitizedCode?: InputMaybe<Scalars['String']['input']>;
};

export enum SampleState {
    Available = 'Available',
    TakenDown = 'TakenDown',
}

export enum SampleType {
    Loop = 'loop',
    OneShot = 'one_shot',
}

export type SampleTypeFilter = {
    __typename?: 'SampleTypeFilter';
    code?: Maybe<Scalars['String']['output']>;
};

export type SamplesIncludedFeature = {
    __typename?: 'SamplesIncludedFeature';
    hasPaidContentAccess: Scalars['Boolean']['output'];
    hasSamplesCredits: Scalars['Boolean']['output'];
    includedCredits: Array<GrantedCredits>;
};

export type Seo = {
    __typename?: 'Seo';
    byline?: Maybe<Scalars['String']['output']>;
    description?: Maybe<Scalars['String']['output']>;
    header?: Maybe<Scalars['String']['output']>;
    title?: Maybe<Scalars['String']['output']>;
    url?: Maybe<Scalars['String']['output']>;
};

export type SeoMetadata = {
    __typename?: 'SeoMetadata';
    description?: Maybe<Scalars['String']['output']>;
    title?: Maybe<Scalars['String']['output']>;
};

export type SeoMetadataInput = {
    description?: InputMaybe<Scalars['String']['input']>;
    title?: InputMaybe<Scalars['String']['input']>;
};

export enum ServiceOfferKind {
    Bundles = 'Bundles',
    Chromatic = 'Chromatic',
    Distribution = 'Distribution',
    Mastering = 'Mastering',
    Mobile = 'Mobile',
    Partners = 'Partners',
    Plugins = 'Plugins',
    PremiumCourses = 'PremiumCourses',
    Samples = 'Samples',
    Sessions = 'Sessions',
    SynchroArts = 'SynchroArts',
    SynchroArtsSubscription = 'SynchroArtsSubscription',
}

export enum ServiceStatusEnum {
    Active = 'Active',
    Cancelled = 'Cancelled',
    Draft = 'Draft',
    Hold = 'Hold',
    Suspended = 'Suspended',
}

export type Sfx = {
    __typename?: 'Sfx';
    code?: Maybe<Scalars['String']['output']>;
    subSfxs?: Maybe<Array<Maybe<SubItems>>>;
};

export type StreamUrl = {
    __typename?: 'StreamUrl';
    url?: Maybe<Scalars['String']['output']>;
};

export type SubItems = {
    __typename?: 'SubItems';
    code?: Maybe<Scalars['String']['output']>;
};

export enum SubscriptionBillingCommitment {
    Monthly = 'Monthly',
    Yearly = 'Yearly',
}

export type SubscriptionCreditsDetails = {
    __typename?: 'SubscriptionCreditsDetails';
    expirationDate?: Maybe<Scalars['Date']['output']>;
    serviceOffer?: Maybe<ServiceOfferKind>;
};

export type SubscriptionDetails = {
    __typename?: 'SubscriptionDetails';
    current: CurrentSubscriptionDetails;
    isTrial: Scalars['Boolean']['output'];
    isTrialingSubscription: Scalars['Boolean']['output'];
    isYearly: Scalars['Boolean']['output'];
    serviceOffer: ServiceOfferKind;
    status: SubscriptionDetailsStatus;
    subscriptionCreditsDetails: Array<SubscriptionCreditsDetails>;
};

export enum SubscriptionDetailsStatus {
    Cancelling = 'Cancelling',
    Downgrading = 'Downgrading',
    Overdue = 'Overdue',
    PauseActive = 'PauseActive',
    PauseScheduled = 'PauseScheduled',
    Subscribed = 'Subscribed',
    Trial = 'Trial',
}

export enum SubscriptionFrequency {
    Monthly = 'Monthly',
    Yearly = 'Yearly',
}

export type SubscriptionPlanProductDetails = {
    __typename?: 'SubscriptionPlanProductDetails';
    code: Scalars['String']['output'];
    currentQuantity: Scalars['Float']['output'];
    endDate?: Maybe<Scalars['String']['output']>;
    isUnlimited: Scalars['Boolean']['output'];
    maxQuantity?: Maybe<Scalars['Float']['output']>;
    numberOfCredits?: Maybe<Scalars['Int']['output']>;
    status: SubscriptionProductStatus;
};

export enum SubscriptionProductStatus {
    Active = 'Active',
    Expired = 'Expired',
}

export enum SubscriptionStatusEnum {
    Active = 'Active',
    Cancelled = 'Cancelled',
    Draft = 'Draft',
    PendingPlanChange = 'PendingPlanChange',
    Suspended = 'Suspended',
}

export type SubscriptionsAndAllowedFeatures = {
    __typename?: 'SubscriptionsAndAllowedFeatures';
    hasSamplesPlan: Scalars['Boolean']['output'];
    hasStudioPlan: Scalars['Boolean']['output'];
    /** @deprecated Use samplesPaidContentAccess instead */
    hasSubscription: Scalars['Boolean']['output'];
    samplePaidContentAccess: AllowedFeature;
    subscriptionsDetails: Array<SubscriptionDetails>;
    upsellingAllowed: Scalars['Boolean']['output'];
};

export type Tag = {
    __typename?: 'Tag';
    category?: Maybe<Scalars['String']['output']>;
    code?: Maybe<Scalars['String']['output']>;
    displayName?: Maybe<Scalars['String']['output']>;
};

export type TagCategoryFilter = {
    __typename?: 'TagCategoryFilter';
    code: Scalars['String']['output'];
    label: Scalars['String']['output'];
};

export type TagsCategory = {
    __typename?: 'TagsCategory';
    category: Scalars['String']['output'];
    list: Array<TagCategoryFilter>;
};

export type Track = {
    __typename?: 'Track';
    bpm?: Maybe<Scalars['Int']['output']>;
    bpmMultiplier: BpmMultiplier;
    gain: Scalars['Int']['output'];
    guid: Scalars['ID']['output'];
    pitchTranspose: Scalars['Int']['output'];
};

export type TrackInput = {
    bpm?: InputMaybe<Scalars['Int']['input']>;
    bpmMultiplier?: InputMaybe<BpmMultiplier>;
    gain?: InputMaybe<Scalars['Int']['input']>;
    guid: Scalars['ID']['input'];
    pitchTranspose?: InputMaybe<Scalars['Int']['input']>;
};

export type UnallowedReason = {
    __typename?: 'UnallowedReason';
    reason: Scalars['String']['output'];
    unallowedByPlan?: Maybe<Scalars['String']['output']>;
};

export type User = {
    __typename?: 'User';
    country?: Maybe<Scalars['String']['output']>;
    creationTime: Scalars['String']['output'];
    displayName?: Maybe<Scalars['String']['output']>;
    email?: Maybe<Scalars['String']['output']>;
    experience?: Maybe<Scalars['String']['output']>;
    firstname?: Maybe<Scalars['String']['output']>;
    hasSeenArchiveNotification: Scalars['Boolean']['output'];
    homePage: HomePageEnum;
    isArchived: Scalars['Boolean']['output'];
    lastname?: Maybe<Scalars['String']['output']>;
    musicGenres?: Maybe<Array<Maybe<MusicGenre>>>;
    permalink?: Maybe<Scalars['String']['output']>;
    preferredCulture?: Maybe<Scalars['String']['output']>;
    primaryOccupation?: Maybe<OccupationEnum>;
    profilePicture72Url?: Maybe<Scalars['String']['output']>;
    profilePicture360Url?: Maybe<Scalars['String']['output']>;
    secondaryOccupations?: Maybe<Array<Maybe<OccupationEnum>>>;
    signupCountry?: Maybe<Scalars['String']['output']>;
    signupCountryCode?: Maybe<Scalars['String']['output']>;
    signupState?: Maybe<Scalars['String']['output']>;
    userId: Scalars['String']['output'];
};

export type UserCollection = {
    __typename?: 'UserCollection';
    artworkUrl?: Maybe<Scalars['String']['output']>;
    guid?: Maybe<Scalars['ID']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    sampleCount?: Maybe<Scalars['Int']['output']>;
    slug?: Maybe<Scalars['String']['output']>;
    userId?: Maybe<Scalars['ID']['output']>;
};

export type UserCollectionsFeed = {
    __typename?: 'UserCollectionsFeed';
    feed?: Maybe<Array<Maybe<UserCollection>>>;
    meta?: Maybe<MetaPage>;
};

export type UserCollectionsFeedFeedArgs = {
    offset?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    query?: InputMaybe<Scalars['String']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
};

export type UserCredits = {
    __typename?: 'UserCredits';
    remaining?: Maybe<Scalars['Int']['output']>;
};

export type UserRecentSearch = {
    __typename?: 'UserRecentSearch';
    filterSlug: Scalars['String']['output'];
    searchFilter: UserSearchFilter;
};

export type UserRecentSearches = {
    __typename?: 'UserRecentSearches';
    recentSearch: Array<UserRecentSearch>;
};

export enum UserSearchFilter {
    Descriptors = 'Descriptors',
    Genres = 'Genres',
    Instruments = 'Instruments',
    Sfxs = 'Sfxs',
    SuggestedLabel = 'SuggestedLabel',
    SuggestedPack = 'SuggestedPack',
    Tags = 'Tags',
    Textsearch = 'Textsearch',
}

export type Waveform = {
    __typename?: 'Waveform';
    guid: Scalars['ID']['output'];
    waveform: Array<Maybe<Scalars['Float']['output']>>;
};

export type ArtistBaseFragmentFragment = {
    __typename?: 'Artist';
    guid: string;
    slug?: string | undefined;
    name?: string | undefined;
    isExclusive: boolean;
};

export type ArtistExcerptFragmentFragment = {
    __typename?: 'Artist';
    artworkUrl?: string | undefined;
    guid: string;
    slug?: string | undefined;
    name?: string | undefined;
    isExclusive: boolean;
};

export type ArtistDetailFragmentFragment = {
    __typename?: 'Artist';
    description?: string | undefined;
    artworkUrl?: string | undefined;
    portraitUrl?: string | undefined;
    coverUrl?: string | undefined;
    isExclusive: boolean;
    sampleCount?: number | undefined;
    packCount?: number | undefined;
    guid: string;
    slug?: string | undefined;
    name?: string | undefined;
};

export type ArtistBySlugQueryVariables = Exact<{
    slug?: InputMaybe<Scalars['String']['input']>;
}>;

export type ArtistBySlugQuery = {
    __typename?: 'Query';
    artistBySlug?:
        | {
              __typename?: 'Artist';
              description?: string | undefined;
              artworkUrl?: string | undefined;
              portraitUrl?: string | undefined;
              coverUrl?: string | undefined;
              isExclusive: boolean;
              sampleCount?: number | undefined;
              packCount?: number | undefined;
              guid: string;
              slug?: string | undefined;
              name?: string | undefined;
          }
        | undefined;
};

export type PaginatedArtistsQueryVariables = Exact<{
    take?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    query?: InputMaybe<Scalars['String']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
}>;

export type PaginatedArtistsQuery = {
    __typename?: 'Query';
    paginatedArtists?:
        | {
              __typename?: 'PaginatedArtists';
              data?:
                  | Array<
                        | {
                              __typename?: 'Artist';
                              artworkUrl?: string | undefined;
                              guid: string;
                              slug?: string | undefined;
                              name?: string | undefined;
                              isExclusive: boolean;
                          }
                        | undefined
                    >
                  | undefined;
              meta?:
                  | {
                        __typename?: 'MetaPage';
                        totalRecords?: number | undefined;
                        totalPackRecords?: number | undefined;
                    }
                  | undefined;
              next?:
                  | { __typename?: 'NextPage'; skip?: number | undefined }
                  | undefined;
          }
        | undefined;
};

export type PaginatedArtistSamplesQueryVariables = Exact<{
    artistGuid?: InputMaybe<Scalars['ID']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    query?: InputMaybe<Scalars['String']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
}>;

export type PaginatedArtistSamplesQuery = {
    __typename?: 'Query';
    paginatedArtistSamples?:
        | {
              __typename?: 'PaginatedSamples';
              data?:
                  | Array<
                        | {
                              __typename?: 'Sample';
                              guid: string;
                              name?: string | undefined;
                              bpm?: number | undefined;
                              credits?: number | undefined;
                              duration?: number | undefined;
                              isDownloaded: boolean;
                              isFavorited: boolean;
                              isRecommendationFiller?: boolean | undefined;
                              sampleState: SampleState;
                              sampleType?: SampleType | undefined;
                              waveformUrl?: string | undefined;
                              key?:
                                  | {
                                        __typename?: 'SampleKey';
                                        code?: string | undefined;
                                        root?: KeyRootApi | undefined;
                                        quality?: KeyQuality | undefined;
                                    }
                                  | undefined;
                              pack?:
                                  | {
                                        __typename?: 'Pack';
                                        artworkUrl?: string | undefined;
                                        guid: string;
                                        isExclusive: boolean;
                                        isFree: boolean;
                                        name?: string | undefined;
                                        packState: PackState;
                                        slug?: string | undefined;
                                        type: PackType;
                                        artist?:
                                            | {
                                                  __typename?: 'Artist';
                                                  guid: string;
                                                  slug?: string | undefined;
                                                  name?: string | undefined;
                                                  isExclusive: boolean;
                                              }
                                            | undefined;
                                        label?:
                                            | {
                                                  __typename?: 'Label';
                                                  guid: string;
                                                  name?: string | undefined;
                                                  slug?: string | undefined;
                                                  isExclusive: boolean;
                                              }
                                            | undefined;
                                    }
                                  | undefined;
                              classifiers: Array<{
                                  __typename?: 'Classifier';
                                  id: string;
                                  code: string;
                                  type: ClassifierType;
                                  isPackClassifier: boolean;
                              }>;
                          }
                        | undefined
                    >
                  | undefined;
              meta?:
                  | {
                        __typename?: 'MetaPage';
                        totalRecords?: number | undefined;
                        totalSampleRecords?: number | undefined;
                        totalPackRecords?: number | undefined;
                        filters?:
                            | {
                                  __typename?: 'Filters';
                                  sampleTypeFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                                  instrumentFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                                  genreFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                                  sfxFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                                  tagFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                              }
                            | undefined;
                    }
                  | undefined;
              next?:
                  | { __typename?: 'NextPage'; skip?: number | undefined }
                  | undefined;
          }
        | undefined;
};

export type PaginatedArtistPacksQueryVariables = Exact<{
    artistGuid?: InputMaybe<Scalars['ID']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    query?: InputMaybe<Scalars['String']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
}>;

export type PaginatedArtistPacksQuery = {
    __typename?: 'Query';
    paginatedArtistPacks?:
        | {
              __typename?: 'PaginatedPacks';
              data?:
                  | Array<
                        | {
                              __typename?: 'Pack';
                              isDownloaded?: boolean | undefined;
                              isFavorited?: boolean | undefined;
                              artworkUrl?: string | undefined;
                              guid: string;
                              isExclusive: boolean;
                              isFree: boolean;
                              name?: string | undefined;
                              packState: PackState;
                              slug?: string | undefined;
                              type: PackType;
                              artist?:
                                  | {
                                        __typename?: 'Artist';
                                        guid: string;
                                        slug?: string | undefined;
                                        name?: string | undefined;
                                        isExclusive: boolean;
                                    }
                                  | undefined;
                              label?:
                                  | {
                                        __typename?: 'Label';
                                        guid: string;
                                        name?: string | undefined;
                                        slug?: string | undefined;
                                        isExclusive: boolean;
                                    }
                                  | undefined;
                          }
                        | undefined
                    >
                  | undefined;
              meta?:
                  | {
                        __typename?: 'MetaPage';
                        totalRecords?: number | undefined;
                        totalSampleRecords?: number | undefined;
                        totalPackRecords?: number | undefined;
                        filters?:
                            | {
                                  __typename?: 'Filters';
                                  sampleTypeFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                                  instrumentFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                                  genreFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                                  sfxFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                                  tagFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                              }
                            | undefined;
                    }
                  | undefined;
              next?:
                  | { __typename?: 'NextPage'; skip?: number | undefined }
                  | undefined;
          }
        | undefined;
};

export type BrandtypeExcerptFragmentFragment = {
    __typename?: 'Brandtype';
    guid: string;
    name?: string | undefined;
    slug?: string | undefined;
};

export type BrandtypeDetailFragmentFragment = {
    __typename?: 'Brandtype';
    description?: string | undefined;
    sampleCount?: number | undefined;
    packCount?: number | undefined;
    guid: string;
    name?: string | undefined;
    slug?: string | undefined;
};

export type PaginatedBrandtypeSamplesQueryVariables = Exact<{
    brandtypeGuid?: InputMaybe<Scalars['ID']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    query?: InputMaybe<Scalars['String']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
}>;

export type PaginatedBrandtypeSamplesQuery = {
    __typename?: 'Query';
    paginatedBrandtypeSamples?:
        | {
              __typename?: 'PaginatedSamples';
              data?:
                  | Array<
                        | {
                              __typename?: 'Sample';
                              guid: string;
                              name?: string | undefined;
                              bpm?: number | undefined;
                              credits?: number | undefined;
                              duration?: number | undefined;
                              isDownloaded: boolean;
                              isFavorited: boolean;
                              isRecommendationFiller?: boolean | undefined;
                              sampleState: SampleState;
                              sampleType?: SampleType | undefined;
                              waveformUrl?: string | undefined;
                              key?:
                                  | {
                                        __typename?: 'SampleKey';
                                        code?: string | undefined;
                                        root?: KeyRootApi | undefined;
                                        quality?: KeyQuality | undefined;
                                    }
                                  | undefined;
                              pack?:
                                  | {
                                        __typename?: 'Pack';
                                        artworkUrl?: string | undefined;
                                        guid: string;
                                        isExclusive: boolean;
                                        isFree: boolean;
                                        name?: string | undefined;
                                        packState: PackState;
                                        slug?: string | undefined;
                                        type: PackType;
                                        artist?:
                                            | {
                                                  __typename?: 'Artist';
                                                  guid: string;
                                                  slug?: string | undefined;
                                                  name?: string | undefined;
                                                  isExclusive: boolean;
                                              }
                                            | undefined;
                                        label?:
                                            | {
                                                  __typename?: 'Label';
                                                  guid: string;
                                                  name?: string | undefined;
                                                  slug?: string | undefined;
                                                  isExclusive: boolean;
                                              }
                                            | undefined;
                                    }
                                  | undefined;
                              classifiers: Array<{
                                  __typename?: 'Classifier';
                                  id: string;
                                  code: string;
                                  type: ClassifierType;
                                  isPackClassifier: boolean;
                              }>;
                          }
                        | undefined
                    >
                  | undefined;
              meta?:
                  | {
                        __typename?: 'MetaPage';
                        totalRecords?: number | undefined;
                        totalSampleRecords?: number | undefined;
                        totalPackRecords?: number | undefined;
                        filters?:
                            | {
                                  __typename?: 'Filters';
                                  sampleTypeFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                                  instrumentFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                                  genreFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                                  sfxFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                                  tagFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                              }
                            | undefined;
                    }
                  | undefined;
              next?:
                  | { __typename?: 'NextPage'; skip?: number | undefined }
                  | undefined;
          }
        | undefined;
};

export type PaginatedBrandtypeRepacksQueryVariables = Exact<{
    brandtypeGuid?: InputMaybe<Scalars['ID']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    query?: InputMaybe<Scalars['String']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
}>;

export type PaginatedBrandtypeRepacksQuery = {
    __typename?: 'Query';
    paginatedBrandtypeRepacks?:
        | {
              __typename?: 'PaginatedRepacks';
              data?:
                  | Array<
                        | {
                              __typename?: 'Repack';
                              artworkUrl?: string | undefined;
                              creatorSession?: string | undefined;
                              guid: string;
                              isDownloaded?: boolean | undefined;
                              isExclusive: boolean;
                              isFavorited?: boolean | undefined;
                              isFree: boolean;
                              name?: string | undefined;
                              packState: PackState;
                              premiumCodes?:
                                  | Array<PremiumCodes | undefined>
                                  | undefined;
                              slug?: string | undefined;
                              subType?: RepackSubType | undefined;
                              type: PackType;
                          }
                        | undefined
                    >
                  | undefined;
              meta?:
                  | {
                        __typename?: 'MetaPage';
                        totalRecords?: number | undefined;
                        totalSampleRecords?: number | undefined;
                        totalPackRecords?: number | undefined;
                        filters?:
                            | {
                                  __typename?: 'Filters';
                                  sampleTypeFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                                  instrumentFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                                  genreFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                                  sfxFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                                  tagFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                              }
                            | undefined;
                    }
                  | undefined;
              next?:
                  | { __typename?: 'NextPage'; skip?: number | undefined }
                  | undefined;
          }
        | undefined;
};

export type BrandtypeBySlugQueryVariables = Exact<{
    slug?: InputMaybe<Scalars['String']['input']>;
}>;

export type BrandtypeBySlugQuery = {
    __typename?: 'Query';
    brandtypeBySlug?:
        | {
              __typename?: 'Brandtype';
              description?: string | undefined;
              sampleCount?: number | undefined;
              packCount?: number | undefined;
              guid: string;
              name?: string | undefined;
              slug?: string | undefined;
          }
        | undefined;
};

export type ChartsTopLabelsQueryVariables = Exact<{ [key: string]: never }>;

export type ChartsTopLabelsQuery = {
    __typename?: 'Query';
    chartsTopLabels?:
        | {
              __typename?: 'LabelsChart';
              items: Array<
                  | {
                        __typename?: 'LabelsChartItem';
                        guid: string;
                        slug: string;
                        name: string;
                        artworkUrl: string;
                        lastRank?: number | undefined;
                        currentRank: number;
                        isNew: boolean;
                        subItemsCount?: number | undefined;
                        artistName?: string | undefined;
                    }
                  | undefined
              >;
          }
        | undefined;
};

export type ChartsTopPacksQueryVariables = Exact<{ [key: string]: never }>;

export type ChartsTopPacksQuery = {
    __typename?: 'Query';
    chartsTopPacks?:
        | {
              __typename?: 'PacksChart';
              items: Array<
                  | {
                        __typename?: 'PacksChartItem';
                        guid: string;
                        slug: string;
                        name: string;
                        artworkUrl: string;
                        lastRank?: number | undefined;
                        currentRank: number;
                        isNew: boolean;
                        subItemsCount?: number | undefined;
                        artistName?: string | undefined;
                    }
                  | undefined
              >;
          }
        | undefined;
};

export type ChartsTopLandrPacksQueryVariables = Exact<{ [key: string]: never }>;

export type ChartsTopLandrPacksQuery = {
    __typename?: 'Query';
    chartsTopLandrPacks?:
        | {
              __typename?: 'RepacksChart';
              items: Array<
                  | {
                        __typename?: 'PacksChartItem';
                        guid: string;
                        slug: string;
                        name: string;
                        artworkUrl: string;
                        lastRank?: number | undefined;
                        currentRank: number;
                        isNew: boolean;
                        subItemsCount?: number | undefined;
                        artistName?: string | undefined;
                    }
                  | undefined
              >;
          }
        | undefined;
};

export type ContentGroupQueryVariables = Exact<{
    guid: Scalars['ID']['input'];
}>;

export type ContentGroupQuery = {
    __typename?: 'Query';
    contentGroup?:
        | {
              __typename?: 'ContentGroup';
              guid: string;
              title: string;
              byline: string;
              target: ContentTarget;
              to?: string | undefined;
              contentLists: Array<
                  | {
                        __typename?: 'ContentList';
                        tabName: string;
                        items: Array<
                            | {
                                  __typename?: 'Pack';
                                  isDownloaded?: boolean | undefined;
                                  isFavorited?: boolean | undefined;
                                  artworkUrl?: string | undefined;
                                  guid: string;
                                  isExclusive: boolean;
                                  isFree: boolean;
                                  name?: string | undefined;
                                  packState: PackState;
                                  slug?: string | undefined;
                                  type: PackType;
                                  artist?:
                                      | {
                                            __typename?: 'Artist';
                                            guid: string;
                                            slug?: string | undefined;
                                            name?: string | undefined;
                                            isExclusive: boolean;
                                        }
                                      | undefined;
                                  label?:
                                      | {
                                            __typename?: 'Label';
                                            guid: string;
                                            name?: string | undefined;
                                            slug?: string | undefined;
                                            isExclusive: boolean;
                                        }
                                      | undefined;
                              }
                            | {
                                  __typename?: 'Repack';
                                  artworkUrl?: string | undefined;
                                  creatorSession?: string | undefined;
                                  guid: string;
                                  isDownloaded?: boolean | undefined;
                                  isExclusive: boolean;
                                  isFavorited?: boolean | undefined;
                                  isFree: boolean;
                                  name?: string | undefined;
                                  packState: PackState;
                                  premiumCodes?:
                                      | Array<PremiumCodes | undefined>
                                      | undefined;
                                  slug?: string | undefined;
                                  subType?: RepackSubType | undefined;
                                  type: PackType;
                              }
                            | undefined
                        >;
                    }
                  | undefined
              >;
          }
        | undefined;
};

export type CostFramentFragment = {
    __typename?: 'CostPreviewResponse';
    credits?: number | undefined;
    remainingCredits?: number | undefined;
    unavailabilityReason?: string | undefined;
};

export type SamplesCostPreviewQueryVariables = Exact<{
    guid?: InputMaybe<
        | Array<InputMaybe<Scalars['String']['input']>>
        | InputMaybe<Scalars['String']['input']>
    >;
}>;

export type SamplesCostPreviewQuery = {
    __typename?: 'Query';
    samplesCostPreview?:
        | {
              __typename?: 'CostPreviewResponse';
              credits?: number | undefined;
              remainingCredits?: number | undefined;
              unavailabilityReason?: string | undefined;
          }
        | undefined;
};

export type CreatorSamplesCostPreviewQueryVariables = Exact<{
    guid?: InputMaybe<
        | Array<InputMaybe<Scalars['String']['input']>>
        | InputMaybe<Scalars['String']['input']>
    >;
}>;

export type CreatorSamplesCostPreviewQuery = {
    __typename?: 'Query';
    creatorSamplesCostPreview?:
        | {
              __typename?: 'CostPreviewResponse';
              credits?: number | undefined;
              remainingCredits?: number | undefined;
              unavailabilityReason?: string | undefined;
          }
        | undefined;
};

export type PackCostPreviewQueryVariables = Exact<{
    guid?: InputMaybe<Scalars['String']['input']>;
}>;

export type PackCostPreviewQuery = {
    __typename?: 'Query';
    packCostPreview?:
        | {
              __typename?: 'CostPreviewResponse';
              credits?: number | undefined;
              remainingCredits?: number | undefined;
              unavailabilityReason?: string | undefined;
          }
        | undefined;
};

export type RepackCostPreviewQueryVariables = Exact<{
    guid?: InputMaybe<Scalars['String']['input']>;
}>;

export type RepackCostPreviewQuery = {
    __typename?: 'Query';
    repackCostPreview?:
        | {
              __typename?: 'CostPreviewResponse';
              credits?: number | undefined;
              remainingCredits?: number | undefined;
              unavailabilityReason?: string | undefined;
          }
        | undefined;
};

export type CollectionCostPreviewQueryVariables = Exact<{
    guid?: InputMaybe<Scalars['String']['input']>;
}>;

export type CollectionCostPreviewQuery = {
    __typename?: 'Query';
    collectionCostPreview?:
        | {
              __typename?: 'CostPreviewResponse';
              credits?: number | undefined;
              remainingCredits?: number | undefined;
              unavailabilityReason?: string | undefined;
          }
        | undefined;
};

export type CreatorKeyFragmentFragment = {
    __typename?: 'Key';
    root: KeyRootApi;
    quality: KeyQuality;
    sign: KeySign;
};

export type TrackFragmentFragment = {
    __typename?: 'Track';
    guid: string;
    bpmMultiplier: BpmMultiplier;
    bpm?: number | undefined;
    gain: number;
    pitchTranspose: number;
};

export type CreatorSessionByIdQueryVariables = Exact<{
    sessionId: Scalars['ID']['input'];
}>;

export type CreatorSessionByIdQuery = {
    __typename?: 'Query';
    creatorSessionById?:
        | {
              __typename?: 'CreatorSession';
              guid: string;
              bpm: number;
              key: {
                  __typename?: 'Key';
                  root: KeyRootApi;
                  quality: KeyQuality;
                  sign: KeySign;
              };
              samples: Array<{
                  __typename?: 'Track';
                  guid: string;
                  bpmMultiplier: BpmMultiplier;
                  bpm?: number | undefined;
                  gain: number;
                  pitchTranspose: number;
              }>;
          }
        | undefined;
};

export type StoreCreatorSessionMutationVariables = Exact<{
    session?: InputMaybe<CreatorSessionInput>;
}>;

export type StoreCreatorSessionMutation = {
    __typename?: 'Mutation';
    storeCreatorSession?:
        | { __typename?: 'CreatorSession'; guid: string }
        | undefined;
};

export type GenreFragmentFragment = {
    __typename?: 'Genre';
    code?: string | undefined;
};

export type InstrumentFragmentFragment = {
    __typename?: 'Instrument';
    code?: string | undefined;
    isFamily?: boolean | undefined;
};

export type SfxFragmentFragment = {
    __typename?: 'Sfx';
    code?: string | undefined;
};

export type TagFragmentFragment = {
    __typename?: 'Tag';
    code?: string | undefined;
    displayName?: string | undefined;
    category?: string | undefined;
};

export type FilterFamilyFragmentFragment = {
    __typename?: 'FilterFamily';
    code: string;
    subFilters?: Array<{ __typename?: 'Filter'; code: string }> | undefined;
};

export type FilterWithLabelFragmentFragment = {
    __typename?: 'FilterWithLabel';
    code: string;
    label: string;
    category: string;
};

export type TagsCategoryFragmentFragment = {
    __typename?: 'TagsCategory';
    category: string;
    list: Array<{
        __typename?: 'TagCategoryFilter';
        code: string;
        label: string;
    }>;
};

export type FiltersQueryVariables = Exact<{ [key: string]: never }>;

export type FiltersQuery = {
    __typename?: 'Query';
    filters?:
        | {
              __typename?: 'FilterCategories';
              instruments?:
                  | Array<{
                        __typename?: 'FilterFamily';
                        code: string;
                        subFilters?:
                            | Array<{ __typename?: 'Filter'; code: string }>
                            | undefined;
                    }>
                  | undefined;
              genres?:
                  | Array<{
                        __typename?: 'FilterFamily';
                        code: string;
                        subFilters?:
                            | Array<{ __typename?: 'Filter'; code: string }>
                            | undefined;
                    }>
                  | undefined;
              sfxs?:
                  | Array<{
                        __typename?: 'FilterFamily';
                        code: string;
                        subFilters?:
                            | Array<{ __typename?: 'Filter'; code: string }>
                            | undefined;
                    }>
                  | undefined;
              tags?:
                  | Array<{
                        __typename?: 'FilterWithLabel';
                        code: string;
                        label: string;
                        category: string;
                    }>
                  | undefined;
              tagsCategories?:
                  | Array<{
                        __typename?: 'TagsCategory';
                        category: string;
                        list: Array<{
                            __typename?: 'TagCategoryFilter';
                            code: string;
                            label: string;
                        }>;
                    }>
                  | undefined;
              sampleTypes?:
                  | Array<{ __typename?: 'Filter'; code: string }>
                  | undefined;
          }
        | undefined;
};

export type HeroBannersQueryVariables = Exact<{ [key: string]: never }>;

export type HeroBannersQuery = {
    __typename?: 'Query';
    heroBanners?:
        | Array<
              | {
                    __typename?: 'HeroBanner';
                    guid: string;
                    contentType: HeroBannerContentType;
                    title?: string | undefined;
                    byline?: string | undefined;
                    description?: string | undefined;
                    customArtworkUrl?: string | undefined;
                    customDemoUrl?: string | undefined;
                    customTags?: Array<string | undefined> | undefined;
                    genres?:
                        | Array<
                              | {
                                    __typename?: 'Genre';
                                    code?: string | undefined;
                                }
                              | undefined
                          >
                        | undefined;
                    instruments?:
                        | Array<
                              | {
                                    __typename?: 'Instrument';
                                    code?: string | undefined;
                                }
                              | undefined
                          >
                        | undefined;
                    entity?:
                        | {
                              __typename?: 'Label';
                              guid: string;
                              name?: string | undefined;
                              slug?: string | undefined;
                              isExclusive: boolean;
                          }
                        | {
                              __typename?: 'Pack';
                              isDownloaded?: boolean | undefined;
                              isFavorited?: boolean | undefined;
                              artworkUrl?: string | undefined;
                              guid: string;
                              isExclusive: boolean;
                              isFree: boolean;
                              name?: string | undefined;
                              packState: PackState;
                              slug?: string | undefined;
                              type: PackType;
                              artist?:
                                  | {
                                        __typename?: 'Artist';
                                        guid: string;
                                        slug?: string | undefined;
                                        name?: string | undefined;
                                        isExclusive: boolean;
                                    }
                                  | undefined;
                              label?:
                                  | {
                                        __typename?: 'Label';
                                        guid: string;
                                        name?: string | undefined;
                                        slug?: string | undefined;
                                        isExclusive: boolean;
                                    }
                                  | undefined;
                          }
                        | {
                              __typename?: 'Repack';
                              artworkUrl?: string | undefined;
                              creatorSession?: string | undefined;
                              guid: string;
                              isDownloaded?: boolean | undefined;
                              isExclusive: boolean;
                              isFavorited?: boolean | undefined;
                              isFree: boolean;
                              name?: string | undefined;
                              packState: PackState;
                              premiumCodes?:
                                  | Array<PremiumCodes | undefined>
                                  | undefined;
                              slug?: string | undefined;
                              subType?: RepackSubType | undefined;
                              type: PackType;
                          }
                        | undefined;
                    labelPacks?:
                        | Array<
                              | {
                                    __typename?: 'Pack';
                                    isDownloaded?: boolean | undefined;
                                    isFavorited?: boolean | undefined;
                                    artworkUrl?: string | undefined;
                                    guid: string;
                                    isExclusive: boolean;
                                    isFree: boolean;
                                    name?: string | undefined;
                                    packState: PackState;
                                    slug?: string | undefined;
                                    type: PackType;
                                    artist?:
                                        | {
                                              __typename?: 'Artist';
                                              guid: string;
                                              slug?: string | undefined;
                                              name?: string | undefined;
                                              isExclusive: boolean;
                                          }
                                        | undefined;
                                    label?:
                                        | {
                                              __typename?: 'Label';
                                              guid: string;
                                              name?: string | undefined;
                                              slug?: string | undefined;
                                              isExclusive: boolean;
                                          }
                                        | undefined;
                                }
                              | undefined
                          >
                        | undefined;
                }
              | undefined
          >
        | undefined;
};

export type LabelBaseFragmentFragment = {
    __typename?: 'Label';
    guid: string;
    name?: string | undefined;
    slug?: string | undefined;
    isExclusive: boolean;
};

export type LabelExcerptFragmentFragment = {
    __typename?: 'Label';
    artworkUrl?: string | undefined;
    guid: string;
    name?: string | undefined;
    slug?: string | undefined;
    isExclusive: boolean;
};

export type LabelDetailFragmentFragment = {
    __typename?: 'Label';
    name?: string | undefined;
    description?: string | undefined;
    artworkUrl?: string | undefined;
    coverUrl?: string | undefined;
    isExclusive: boolean;
    sampleCount?: number | undefined;
    packCount?: number | undefined;
    guid: string;
    slug?: string | undefined;
};

export type PaginatedLabelsQueryVariables = Exact<{
    take?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    query?: InputMaybe<Scalars['String']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
}>;

export type PaginatedLabelsQuery = {
    __typename?: 'Query';
    paginatedLabels?:
        | {
              __typename?: 'PaginatedLabels';
              data?:
                  | Array<
                        | {
                              __typename?: 'Label';
                              artworkUrl?: string | undefined;
                              guid: string;
                              name?: string | undefined;
                              slug?: string | undefined;
                              isExclusive: boolean;
                          }
                        | undefined
                    >
                  | undefined;
              meta?:
                  | {
                        __typename?: 'MetaPage';
                        totalRecords?: number | undefined;
                        totalPackRecords?: number | undefined;
                    }
                  | undefined;
              next?:
                  | { __typename?: 'NextPage'; skip?: number | undefined }
                  | undefined;
          }
        | undefined;
};

export type PaginatedLabelSamplesQueryVariables = Exact<{
    labelGuid?: InputMaybe<Scalars['ID']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    query?: InputMaybe<Scalars['String']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
}>;

export type PaginatedLabelSamplesQuery = {
    __typename?: 'Query';
    paginatedLabelSamples?:
        | {
              __typename?: 'PaginatedSamples';
              data?:
                  | Array<
                        | {
                              __typename?: 'Sample';
                              guid: string;
                              name?: string | undefined;
                              bpm?: number | undefined;
                              credits?: number | undefined;
                              duration?: number | undefined;
                              isDownloaded: boolean;
                              isFavorited: boolean;
                              isRecommendationFiller?: boolean | undefined;
                              sampleState: SampleState;
                              sampleType?: SampleType | undefined;
                              waveformUrl?: string | undefined;
                              key?:
                                  | {
                                        __typename?: 'SampleKey';
                                        code?: string | undefined;
                                        root?: KeyRootApi | undefined;
                                        quality?: KeyQuality | undefined;
                                    }
                                  | undefined;
                              pack?:
                                  | {
                                        __typename?: 'Pack';
                                        artworkUrl?: string | undefined;
                                        guid: string;
                                        isExclusive: boolean;
                                        isFree: boolean;
                                        name?: string | undefined;
                                        packState: PackState;
                                        slug?: string | undefined;
                                        type: PackType;
                                        artist?:
                                            | {
                                                  __typename?: 'Artist';
                                                  guid: string;
                                                  slug?: string | undefined;
                                                  name?: string | undefined;
                                                  isExclusive: boolean;
                                              }
                                            | undefined;
                                        label?:
                                            | {
                                                  __typename?: 'Label';
                                                  guid: string;
                                                  name?: string | undefined;
                                                  slug?: string | undefined;
                                                  isExclusive: boolean;
                                              }
                                            | undefined;
                                    }
                                  | undefined;
                              classifiers: Array<{
                                  __typename?: 'Classifier';
                                  id: string;
                                  code: string;
                                  type: ClassifierType;
                                  isPackClassifier: boolean;
                              }>;
                          }
                        | undefined
                    >
                  | undefined;
              meta?:
                  | {
                        __typename?: 'MetaPage';
                        totalRecords?: number | undefined;
                        totalSampleRecords?: number | undefined;
                        totalPackRecords?: number | undefined;
                        filters?:
                            | {
                                  __typename?: 'Filters';
                                  sampleTypeFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                                  instrumentFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                                  genreFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                                  sfxFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                                  tagFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                              }
                            | undefined;
                    }
                  | undefined;
              next?:
                  | { __typename?: 'NextPage'; skip?: number | undefined }
                  | undefined;
          }
        | undefined;
};

export type PaginatedLabelPacksQueryVariables = Exact<{
    labelGuid?: InputMaybe<Scalars['ID']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    query?: InputMaybe<Scalars['String']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
}>;

export type PaginatedLabelPacksQuery = {
    __typename?: 'Query';
    paginatedLabelPacks?:
        | {
              __typename?: 'PaginatedPacks';
              data?:
                  | Array<
                        | {
                              __typename?: 'Pack';
                              isDownloaded?: boolean | undefined;
                              isFavorited?: boolean | undefined;
                              artworkUrl?: string | undefined;
                              guid: string;
                              isExclusive: boolean;
                              isFree: boolean;
                              name?: string | undefined;
                              packState: PackState;
                              slug?: string | undefined;
                              type: PackType;
                              artist?:
                                  | {
                                        __typename?: 'Artist';
                                        guid: string;
                                        slug?: string | undefined;
                                        name?: string | undefined;
                                        isExclusive: boolean;
                                    }
                                  | undefined;
                              label?:
                                  | {
                                        __typename?: 'Label';
                                        guid: string;
                                        name?: string | undefined;
                                        slug?: string | undefined;
                                        isExclusive: boolean;
                                    }
                                  | undefined;
                          }
                        | undefined
                    >
                  | undefined;
              meta?:
                  | {
                        __typename?: 'MetaPage';
                        totalRecords?: number | undefined;
                        totalSampleRecords?: number | undefined;
                        totalPackRecords?: number | undefined;
                        filters?:
                            | {
                                  __typename?: 'Filters';
                                  sampleTypeFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                                  instrumentFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                                  genreFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                                  sfxFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                                  tagFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                              }
                            | undefined;
                    }
                  | undefined;
              next?:
                  | { __typename?: 'NextPage'; skip?: number | undefined }
                  | undefined;
          }
        | undefined;
};

export type LabelBySlugQueryVariables = Exact<{
    slug?: InputMaybe<Scalars['String']['input']>;
}>;

export type LabelBySlugQuery = {
    __typename?: 'Query';
    labelBySlug?:
        | {
              __typename?: 'Label';
              name?: string | undefined;
              description?: string | undefined;
              artworkUrl?: string | undefined;
              coverUrl?: string | undefined;
              isExclusive: boolean;
              sampleCount?: number | undefined;
              packCount?: number | undefined;
              guid: string;
              slug?: string | undefined;
          }
        | undefined;
};

export type MerchZoneQueryVariables = Exact<{
    slug: Scalars['ID']['input'];
}>;

export type MerchZoneQuery = {
    __typename?: 'Query';
    merchZone?:
        | {
              __typename?: 'MerchZone';
              contentGroups: Array<{
                  __typename?: 'ContentGroup';
                  guid: string;
                  title: string;
                  byline: string;
                  target: ContentTarget;
                  to?: string | undefined;
              }>;
          }
        | undefined;
};

export type MetaPageFilterFragmentFragment = {
    __typename?: 'MetaPage';
    filters?:
        | {
              __typename?: 'Filters';
              sampleTypeFilters?:
                  | Array<
                        | {
                              __typename?: 'FilterMeta';
                              name?: string | undefined;
                              value?: number | undefined;
                          }
                        | undefined
                    >
                  | undefined;
              instrumentFilters?:
                  | Array<
                        | {
                              __typename?: 'FilterMeta';
                              name?: string | undefined;
                              value?: number | undefined;
                          }
                        | undefined
                    >
                  | undefined;
              genreFilters?:
                  | Array<
                        | {
                              __typename?: 'FilterMeta';
                              name?: string | undefined;
                              value?: number | undefined;
                          }
                        | undefined
                    >
                  | undefined;
              sfxFilters?:
                  | Array<
                        | {
                              __typename?: 'FilterMeta';
                              name?: string | undefined;
                              value?: number | undefined;
                          }
                        | undefined
                    >
                  | undefined;
              tagFilters?:
                  | Array<
                        | {
                              __typename?: 'FilterMeta';
                              name?: string | undefined;
                              value?: number | undefined;
                          }
                        | undefined
                    >
                  | undefined;
          }
        | undefined;
};

export type MetaPageTotalFragmentFragment = {
    __typename?: 'MetaPage';
    totalRecords?: number | undefined;
    totalSampleRecords?: number | undefined;
    totalPackRecords?: number | undefined;
};

export type MilestonesQueryVariables = Exact<{ [key: string]: never }>;

export type MilestonesQuery = {
    __typename?: 'Query';
    milestones: Array<string>;
};

export type PutMilestonesMutationVariables = Exact<{
    milestones: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;

export type PutMilestonesMutation = {
    __typename?: 'Mutation';
    putMilestones: Array<string>;
};

export type PackBaseFragmentFragment = {
    __typename?: 'Pack';
    artworkUrl?: string | undefined;
    guid: string;
    isExclusive: boolean;
    isFree: boolean;
    name?: string | undefined;
    packState: PackState;
    slug?: string | undefined;
    type: PackType;
    artist?:
        | {
              __typename?: 'Artist';
              guid: string;
              slug?: string | undefined;
              name?: string | undefined;
              isExclusive: boolean;
          }
        | undefined;
    label?:
        | {
              __typename?: 'Label';
              guid: string;
              name?: string | undefined;
              slug?: string | undefined;
              isExclusive: boolean;
          }
        | undefined;
};

export type PackExcerptFragmentFragment = {
    __typename?: 'Pack';
    isDownloaded?: boolean | undefined;
    isFavorited?: boolean | undefined;
    artworkUrl?: string | undefined;
    guid: string;
    isExclusive: boolean;
    isFree: boolean;
    name?: string | undefined;
    packState: PackState;
    slug?: string | undefined;
    type: PackType;
    artist?:
        | {
              __typename?: 'Artist';
              guid: string;
              slug?: string | undefined;
              name?: string | undefined;
              isExclusive: boolean;
          }
        | undefined;
    label?:
        | {
              __typename?: 'Label';
              guid: string;
              name?: string | undefined;
              slug?: string | undefined;
              isExclusive: boolean;
          }
        | undefined;
};

export type PackDetailFragmentFragment = {
    __typename?: 'Pack';
    backgroundColor?: string | undefined;
    creatorSession?: string | undefined;
    description?: string | undefined;
    foregroundColor?: string | undefined;
    premiumCodes?: Array<PremiumCodes | undefined> | undefined;
    sampleCount?: number | undefined;
    isDownloaded?: boolean | undefined;
    isFavorited?: boolean | undefined;
    artworkUrl?: string | undefined;
    guid: string;
    isExclusive: boolean;
    isFree: boolean;
    name?: string | undefined;
    packState: PackState;
    slug?: string | undefined;
    type: PackType;
    genres?:
        | Array<{ __typename?: 'Genre'; code?: string | undefined } | undefined>
        | undefined;
    mainGenre?: { __typename?: 'Genre'; code?: string | undefined } | undefined;
    sfxs?:
        | Array<{ __typename?: 'Sfx'; code?: string | undefined } | undefined>
        | undefined;
    artist?:
        | {
              __typename?: 'Artist';
              guid: string;
              slug?: string | undefined;
              name?: string | undefined;
              isExclusive: boolean;
          }
        | undefined;
    label?:
        | {
              __typename?: 'Label';
              guid: string;
              name?: string | undefined;
              slug?: string | undefined;
              isExclusive: boolean;
          }
        | undefined;
};

export type PaginatedPackSamplesQueryVariables = Exact<{
    packGuid?: InputMaybe<Scalars['ID']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    query?: InputMaybe<Scalars['String']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
}>;

export type PaginatedPackSamplesQuery = {
    __typename?: 'Query';
    paginatedPackSamples?:
        | {
              __typename?: 'PaginatedSamples';
              data?:
                  | Array<
                        | {
                              __typename?: 'Sample';
                              guid: string;
                              name?: string | undefined;
                              bpm?: number | undefined;
                              credits?: number | undefined;
                              duration?: number | undefined;
                              isDownloaded: boolean;
                              isFavorited: boolean;
                              isRecommendationFiller?: boolean | undefined;
                              sampleState: SampleState;
                              sampleType?: SampleType | undefined;
                              waveformUrl?: string | undefined;
                              key?:
                                  | {
                                        __typename?: 'SampleKey';
                                        code?: string | undefined;
                                        root?: KeyRootApi | undefined;
                                        quality?: KeyQuality | undefined;
                                    }
                                  | undefined;
                              pack?:
                                  | {
                                        __typename?: 'Pack';
                                        artworkUrl?: string | undefined;
                                        guid: string;
                                        isExclusive: boolean;
                                        isFree: boolean;
                                        name?: string | undefined;
                                        packState: PackState;
                                        slug?: string | undefined;
                                        type: PackType;
                                        artist?:
                                            | {
                                                  __typename?: 'Artist';
                                                  guid: string;
                                                  slug?: string | undefined;
                                                  name?: string | undefined;
                                                  isExclusive: boolean;
                                              }
                                            | undefined;
                                        label?:
                                            | {
                                                  __typename?: 'Label';
                                                  guid: string;
                                                  name?: string | undefined;
                                                  slug?: string | undefined;
                                                  isExclusive: boolean;
                                              }
                                            | undefined;
                                    }
                                  | undefined;
                              classifiers: Array<{
                                  __typename?: 'Classifier';
                                  id: string;
                                  code: string;
                                  type: ClassifierType;
                                  isPackClassifier: boolean;
                              }>;
                          }
                        | undefined
                    >
                  | undefined;
              meta?:
                  | {
                        __typename?: 'MetaPage';
                        totalRecords?: number | undefined;
                        totalSampleRecords?: number | undefined;
                        totalPackRecords?: number | undefined;
                        filters?:
                            | {
                                  __typename?: 'Filters';
                                  sampleTypeFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                                  instrumentFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                                  genreFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                                  sfxFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                                  tagFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                              }
                            | undefined;
                    }
                  | undefined;
              next?:
                  | { __typename?: 'NextPage'; skip?: number | undefined }
                  | undefined;
          }
        | undefined;
};

export type PackBySlugOrGuidQueryVariables = Exact<{
    packSlugOrGuid: Scalars['ID']['input'];
}>;

export type PackBySlugOrGuidQuery = {
    __typename?: 'Query';
    pack?:
        | {
              __typename?: 'Pack';
              backgroundColor?: string | undefined;
              creatorSession?: string | undefined;
              description?: string | undefined;
              foregroundColor?: string | undefined;
              premiumCodes?: Array<PremiumCodes | undefined> | undefined;
              sampleCount?: number | undefined;
              isDownloaded?: boolean | undefined;
              isFavorited?: boolean | undefined;
              artworkUrl?: string | undefined;
              guid: string;
              isExclusive: boolean;
              isFree: boolean;
              name?: string | undefined;
              packState: PackState;
              slug?: string | undefined;
              type: PackType;
              genres?:
                  | Array<
                        | { __typename?: 'Genre'; code?: string | undefined }
                        | undefined
                    >
                  | undefined;
              mainGenre?:
                  | { __typename?: 'Genre'; code?: string | undefined }
                  | undefined;
              sfxs?:
                  | Array<
                        | { __typename?: 'Sfx'; code?: string | undefined }
                        | undefined
                    >
                  | undefined;
              artist?:
                  | {
                        __typename?: 'Artist';
                        guid: string;
                        slug?: string | undefined;
                        name?: string | undefined;
                        isExclusive: boolean;
                    }
                  | undefined;
              label?:
                  | {
                        __typename?: 'Label';
                        guid: string;
                        name?: string | undefined;
                        slug?: string | undefined;
                        isExclusive: boolean;
                    }
                  | undefined;
          }
        | undefined;
};

export type SimilarPacksQueryVariables = Exact<{
    packSlugOrGuid: Scalars['ID']['input'];
}>;

export type SimilarPacksQuery = {
    __typename?: 'Query';
    similarPacks?:
        | {
              __typename?: 'PaginatedPacks';
              data?:
                  | Array<
                        | {
                              __typename?: 'Pack';
                              isDownloaded?: boolean | undefined;
                              isFavorited?: boolean | undefined;
                              artworkUrl?: string | undefined;
                              guid: string;
                              isExclusive: boolean;
                              isFree: boolean;
                              name?: string | undefined;
                              packState: PackState;
                              slug?: string | undefined;
                              type: PackType;
                              artist?:
                                  | {
                                        __typename?: 'Artist';
                                        guid: string;
                                        slug?: string | undefined;
                                        name?: string | undefined;
                                        isExclusive: boolean;
                                    }
                                  | undefined;
                              label?:
                                  | {
                                        __typename?: 'Label';
                                        guid: string;
                                        name?: string | undefined;
                                        slug?: string | undefined;
                                        isExclusive: boolean;
                                    }
                                  | undefined;
                          }
                        | undefined
                    >
                  | undefined;
          }
        | undefined;
};

export type PackIsDownloadedQueryVariables = Exact<{
    guid: Scalars['ID']['input'];
}>;

export type PackIsDownloadedQuery = {
    __typename?: 'Query';
    pack?:
        | {
              __typename?: 'Pack';
              guid: string;
              isDownloaded?: boolean | undefined;
          }
        | undefined;
};

export type UpdatePackFavoritedStateMutationVariables = Exact<{
    pack: PackFavoritedInput;
}>;

export type UpdatePackFavoritedStateMutation = {
    __typename?: 'Mutation';
    updatePackFavoritedState?:
        | {
              __typename?: 'Pack';
              guid: string;
              isFavorited?: boolean | undefined;
          }
        | undefined;
};

export type PacksStreamQueryVariables = Exact<{
    packGuid: Scalars['ID']['input'];
}>;

export type PacksStreamQuery = {
    __typename?: 'Query';
    packStream?:
        | { __typename?: 'StreamUrl'; url?: string | undefined }
        | undefined;
};

export type PaginatedPacksAndRepacksQueryVariables = Exact<{
    take?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    query?: InputMaybe<Scalars['String']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
}>;

export type PaginatedPacksAndRepacksQuery = {
    __typename?: 'Query';
    paginatedPacksAndRepacks?:
        | {
              __typename?: 'PaginatedPacksOrRepacks';
              data?:
                  | Array<
                        | {
                              __typename?: 'Pack';
                              isDownloaded?: boolean | undefined;
                              isFavorited?: boolean | undefined;
                              artworkUrl?: string | undefined;
                              guid: string;
                              isExclusive: boolean;
                              isFree: boolean;
                              name?: string | undefined;
                              packState: PackState;
                              slug?: string | undefined;
                              type: PackType;
                              artist?:
                                  | {
                                        __typename?: 'Artist';
                                        guid: string;
                                        slug?: string | undefined;
                                        name?: string | undefined;
                                        isExclusive: boolean;
                                    }
                                  | undefined;
                              label?:
                                  | {
                                        __typename?: 'Label';
                                        guid: string;
                                        name?: string | undefined;
                                        slug?: string | undefined;
                                        isExclusive: boolean;
                                    }
                                  | undefined;
                          }
                        | {
                              __typename?: 'Repack';
                              artworkUrl?: string | undefined;
                              creatorSession?: string | undefined;
                              guid: string;
                              isDownloaded?: boolean | undefined;
                              isExclusive: boolean;
                              isFavorited?: boolean | undefined;
                              isFree: boolean;
                              name?: string | undefined;
                              packState: PackState;
                              premiumCodes?:
                                  | Array<PremiumCodes | undefined>
                                  | undefined;
                              slug?: string | undefined;
                              subType?: RepackSubType | undefined;
                              type: PackType;
                          }
                        | undefined
                    >
                  | undefined;
              meta?:
                  | {
                        __typename?: 'MetaPage';
                        totalRecords?: number | undefined;
                        totalSampleRecords?: number | undefined;
                        totalPackRecords?: number | undefined;
                        filters?:
                            | {
                                  __typename?: 'Filters';
                                  sampleTypeFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                                  instrumentFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                                  genreFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                                  sfxFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                                  tagFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                              }
                            | undefined;
                    }
                  | undefined;
              next?:
                  | { __typename?: 'NextPage'; skip?: number | undefined }
                  | undefined;
          }
        | undefined;
};

export type PaginatedDownloadedPacksAndRepacksQueryVariables = Exact<{
    take?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    query?: InputMaybe<Scalars['String']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
}>;

export type PaginatedDownloadedPacksAndRepacksQuery = {
    __typename?: 'Query';
    paginatedDownloadedPacksAndRepacksV2?:
        | {
              __typename?: 'PaginatedPacksOrRepacks';
              data?:
                  | Array<
                        | {
                              __typename?: 'Pack';
                              isDownloaded?: boolean | undefined;
                              isFavorited?: boolean | undefined;
                              artworkUrl?: string | undefined;
                              guid: string;
                              isExclusive: boolean;
                              isFree: boolean;
                              name?: string | undefined;
                              packState: PackState;
                              slug?: string | undefined;
                              type: PackType;
                              artist?:
                                  | {
                                        __typename?: 'Artist';
                                        guid: string;
                                        slug?: string | undefined;
                                        name?: string | undefined;
                                        isExclusive: boolean;
                                    }
                                  | undefined;
                              label?:
                                  | {
                                        __typename?: 'Label';
                                        guid: string;
                                        name?: string | undefined;
                                        slug?: string | undefined;
                                        isExclusive: boolean;
                                    }
                                  | undefined;
                          }
                        | {
                              __typename?: 'Repack';
                              artworkUrl?: string | undefined;
                              creatorSession?: string | undefined;
                              guid: string;
                              isDownloaded?: boolean | undefined;
                              isExclusive: boolean;
                              isFavorited?: boolean | undefined;
                              isFree: boolean;
                              name?: string | undefined;
                              packState: PackState;
                              premiumCodes?:
                                  | Array<PremiumCodes | undefined>
                                  | undefined;
                              slug?: string | undefined;
                              subType?: RepackSubType | undefined;
                              type: PackType;
                          }
                        | undefined
                    >
                  | undefined;
              meta?:
                  | {
                        __typename?: 'MetaPage';
                        totalRecords?: number | undefined;
                        totalSampleRecords?: number | undefined;
                        totalPackRecords?: number | undefined;
                        filters?:
                            | {
                                  __typename?: 'Filters';
                                  sampleTypeFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                                  instrumentFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                                  genreFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                                  sfxFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                                  tagFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                              }
                            | undefined;
                    }
                  | undefined;
              next?:
                  | { __typename?: 'NextPage'; skip?: number | undefined }
                  | undefined;
          }
        | undefined;
};

export type PaginatedFavoritedPacksAndRepacksQueryVariables = Exact<{
    take?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    query?: InputMaybe<Scalars['String']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
}>;

export type PaginatedFavoritedPacksAndRepacksQuery = {
    __typename?: 'Query';
    paginatedFavoritedPacksAndRepacksV2?:
        | {
              __typename?: 'PaginatedPacksOrRepacks';
              data?:
                  | Array<
                        | {
                              __typename?: 'Pack';
                              isDownloaded?: boolean | undefined;
                              isFavorited?: boolean | undefined;
                              artworkUrl?: string | undefined;
                              guid: string;
                              isExclusive: boolean;
                              isFree: boolean;
                              name?: string | undefined;
                              packState: PackState;
                              slug?: string | undefined;
                              type: PackType;
                              artist?:
                                  | {
                                        __typename?: 'Artist';
                                        guid: string;
                                        slug?: string | undefined;
                                        name?: string | undefined;
                                        isExclusive: boolean;
                                    }
                                  | undefined;
                              label?:
                                  | {
                                        __typename?: 'Label';
                                        guid: string;
                                        name?: string | undefined;
                                        slug?: string | undefined;
                                        isExclusive: boolean;
                                    }
                                  | undefined;
                          }
                        | {
                              __typename?: 'Repack';
                              artworkUrl?: string | undefined;
                              creatorSession?: string | undefined;
                              guid: string;
                              isDownloaded?: boolean | undefined;
                              isExclusive: boolean;
                              isFavorited?: boolean | undefined;
                              isFree: boolean;
                              name?: string | undefined;
                              packState: PackState;
                              premiumCodes?:
                                  | Array<PremiumCodes | undefined>
                                  | undefined;
                              slug?: string | undefined;
                              subType?: RepackSubType | undefined;
                              type: PackType;
                          }
                        | undefined
                    >
                  | undefined;
              meta?:
                  | {
                        __typename?: 'MetaPage';
                        totalRecords?: number | undefined;
                        totalSampleRecords?: number | undefined;
                        totalPackRecords?: number | undefined;
                        filters?:
                            | {
                                  __typename?: 'Filters';
                                  sampleTypeFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                                  instrumentFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                                  genreFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                                  sfxFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                                  tagFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                              }
                            | undefined;
                    }
                  | undefined;
              next?:
                  | { __typename?: 'NextPage'; skip?: number | undefined }
                  | undefined;
          }
        | undefined;
};

export type SamplesPurchaseQueryVariables = Exact<{
    guid?: InputMaybe<
        | Array<InputMaybe<Scalars['String']['input']>>
        | InputMaybe<Scalars['String']['input']>
    >;
    interactionSource?: InputMaybe<Scalars['String']['input']>;
}>;

export type SamplesPurchaseQuery = {
    __typename?: 'Query';
    samplesPurchase?:
        | { __typename?: 'PurchaseResponse'; url?: string | undefined }
        | undefined;
};

export type CreatorSamplesPurchaseQueryVariables = Exact<{
    purchasableItem: PurchasableCreatorSession;
    interactionSource?: InputMaybe<Scalars['String']['input']>;
}>;

export type CreatorSamplesPurchaseQuery = {
    __typename?: 'Query';
    creatorSamplesPurchase?:
        | { __typename?: 'PurchaseResponse'; url?: string | undefined }
        | undefined;
};

export type CreatorMixdownPurchaseQueryVariables = Exact<{
    purchasableItem: PurchasableCreatorSession;
    interactionSource?: InputMaybe<Scalars['String']['input']>;
}>;

export type CreatorMixdownPurchaseQuery = {
    __typename?: 'Query';
    creatorMixdownPurchase?:
        | { __typename?: 'PurchaseResponse'; url?: string | undefined }
        | undefined;
};

export type PackPurchaseQueryVariables = Exact<{
    guid?: InputMaybe<Scalars['String']['input']>;
    interactionSource?: InputMaybe<Scalars['String']['input']>;
}>;

export type PackPurchaseQuery = {
    __typename?: 'Query';
    packPurchase?:
        | { __typename?: 'PurchaseResponse'; url?: string | undefined }
        | undefined;
};

export type RepackPurchaseQueryVariables = Exact<{
    guid?: InputMaybe<Scalars['String']['input']>;
    interactionSource?: InputMaybe<Scalars['String']['input']>;
}>;

export type RepackPurchaseQuery = {
    __typename?: 'Query';
    repackPurchase?:
        | { __typename?: 'PurchaseResponse'; url?: string | undefined }
        | undefined;
};

export type CollectionPurchaseQueryVariables = Exact<{
    guid?: InputMaybe<Scalars['String']['input']>;
    interactionSource?: InputMaybe<Scalars['String']['input']>;
}>;

export type CollectionPurchaseQuery = {
    __typename?: 'Query';
    collectionPurchase?:
        | { __typename?: 'PurchaseResponse'; url?: string | undefined }
        | undefined;
};

export type RepackExcerptFragmentFragment = {
    __typename?: 'Repack';
    artworkUrl?: string | undefined;
    creatorSession?: string | undefined;
    guid: string;
    isDownloaded?: boolean | undefined;
    isExclusive: boolean;
    isFavorited?: boolean | undefined;
    isFree: boolean;
    name?: string | undefined;
    packState: PackState;
    premiumCodes?: Array<PremiumCodes | undefined> | undefined;
    slug?: string | undefined;
    subType?: RepackSubType | undefined;
    type: PackType;
};

export type RepackDetailFragmentFragment = {
    __typename?: 'Repack';
    backgroundColor?: string | undefined;
    creatorSession?: string | undefined;
    description?: string | undefined;
    foregroundColor?: string | undefined;
    sampleCount?: number | undefined;
    artworkUrl?: string | undefined;
    guid: string;
    isDownloaded?: boolean | undefined;
    isExclusive: boolean;
    isFavorited?: boolean | undefined;
    isFree: boolean;
    name?: string | undefined;
    packState: PackState;
    premiumCodes?: Array<PremiumCodes | undefined> | undefined;
    slug?: string | undefined;
    subType?: RepackSubType | undefined;
    type: PackType;
    instrument?:
        | { __typename?: 'Instrument'; code?: string | undefined }
        | undefined;
    mainGenre?: { __typename?: 'Genre'; code?: string | undefined } | undefined;
    genres?:
        | Array<{ __typename?: 'Genre'; code?: string | undefined } | undefined>
        | undefined;
    sfxs?:
        | Array<{ __typename?: 'Sfx'; code?: string | undefined } | undefined>
        | undefined;
    artist?:
        | {
              __typename?: 'Artist';
              guid: string;
              slug?: string | undefined;
              name?: string | undefined;
              isExclusive: boolean;
          }
        | undefined;
    label?:
        | {
              __typename?: 'Label';
              guid: string;
              name?: string | undefined;
              slug?: string | undefined;
              isExclusive: boolean;
          }
        | undefined;
    brandtype?:
        | {
              __typename?: 'Brandtype';
              guid: string;
              name?: string | undefined;
              slug?: string | undefined;
          }
        | undefined;
};

export type PaginatedRepacksQueryVariables = Exact<{
    take?: InputMaybe<Scalars['Int']['input']>;
    subType?: InputMaybe<RepackSubType>;
    page?: InputMaybe<Scalars['Int']['input']>;
    query?: InputMaybe<Scalars['String']['input']>;
}>;

export type PaginatedRepacksQuery = {
    __typename?: 'Query';
    paginatedRepacks?:
        | {
              __typename?: 'PaginatedRepacks';
              data?:
                  | Array<
                        | {
                              __typename?: 'Repack';
                              artworkUrl?: string | undefined;
                              creatorSession?: string | undefined;
                              guid: string;
                              isDownloaded?: boolean | undefined;
                              isExclusive: boolean;
                              isFavorited?: boolean | undefined;
                              isFree: boolean;
                              name?: string | undefined;
                              packState: PackState;
                              premiumCodes?:
                                  | Array<PremiumCodes | undefined>
                                  | undefined;
                              slug?: string | undefined;
                              subType?: RepackSubType | undefined;
                              type: PackType;
                          }
                        | undefined
                    >
                  | undefined;
              meta?:
                  | {
                        __typename?: 'MetaPage';
                        totalRecords?: number | undefined;
                        totalSampleRecords?: number | undefined;
                        totalPackRecords?: number | undefined;
                        filters?:
                            | {
                                  __typename?: 'Filters';
                                  sampleTypeFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                                  instrumentFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                                  genreFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                                  sfxFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                                  tagFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                              }
                            | undefined;
                    }
                  | undefined;
          }
        | undefined;
};

export type RepackBySlugOrGuidQueryVariables = Exact<{
    repackSlugOrGuid: Scalars['ID']['input'];
}>;

export type RepackBySlugOrGuidQuery = {
    __typename?: 'Query';
    repack?:
        | {
              __typename?: 'Repack';
              backgroundColor?: string | undefined;
              creatorSession?: string | undefined;
              description?: string | undefined;
              foregroundColor?: string | undefined;
              sampleCount?: number | undefined;
              artworkUrl?: string | undefined;
              guid: string;
              isDownloaded?: boolean | undefined;
              isExclusive: boolean;
              isFavorited?: boolean | undefined;
              isFree: boolean;
              name?: string | undefined;
              packState: PackState;
              premiumCodes?: Array<PremiumCodes | undefined> | undefined;
              slug?: string | undefined;
              subType?: RepackSubType | undefined;
              type: PackType;
              instrument?:
                  | { __typename?: 'Instrument'; code?: string | undefined }
                  | undefined;
              mainGenre?:
                  | { __typename?: 'Genre'; code?: string | undefined }
                  | undefined;
              genres?:
                  | Array<
                        | { __typename?: 'Genre'; code?: string | undefined }
                        | undefined
                    >
                  | undefined;
              sfxs?:
                  | Array<
                        | { __typename?: 'Sfx'; code?: string | undefined }
                        | undefined
                    >
                  | undefined;
              artist?:
                  | {
                        __typename?: 'Artist';
                        guid: string;
                        slug?: string | undefined;
                        name?: string | undefined;
                        isExclusive: boolean;
                    }
                  | undefined;
              label?:
                  | {
                        __typename?: 'Label';
                        guid: string;
                        name?: string | undefined;
                        slug?: string | undefined;
                        isExclusive: boolean;
                    }
                  | undefined;
              brandtype?:
                  | {
                        __typename?: 'Brandtype';
                        guid: string;
                        name?: string | undefined;
                        slug?: string | undefined;
                    }
                  | undefined;
          }
        | undefined;
};

export type RepackIsDownloadedQueryVariables = Exact<{
    guid: Scalars['ID']['input'];
}>;

export type RepackIsDownloadedQuery = {
    __typename?: 'Query';
    repack?:
        | {
              __typename?: 'Repack';
              guid: string;
              isDownloaded?: boolean | undefined;
          }
        | undefined;
};

export type PaginatedRepackSamplesQueryVariables = Exact<{
    repackGuid?: InputMaybe<Scalars['ID']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    query?: InputMaybe<Scalars['String']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
}>;

export type PaginatedRepackSamplesQuery = {
    __typename?: 'Query';
    paginatedRepackSamples?:
        | {
              __typename?: 'PaginatedSamples';
              data?:
                  | Array<
                        | {
                              __typename?: 'Sample';
                              guid: string;
                              name?: string | undefined;
                              bpm?: number | undefined;
                              credits?: number | undefined;
                              duration?: number | undefined;
                              isDownloaded: boolean;
                              isFavorited: boolean;
                              isRecommendationFiller?: boolean | undefined;
                              sampleState: SampleState;
                              sampleType?: SampleType | undefined;
                              waveformUrl?: string | undefined;
                              key?:
                                  | {
                                        __typename?: 'SampleKey';
                                        code?: string | undefined;
                                        root?: KeyRootApi | undefined;
                                        quality?: KeyQuality | undefined;
                                    }
                                  | undefined;
                              pack?:
                                  | {
                                        __typename?: 'Pack';
                                        artworkUrl?: string | undefined;
                                        guid: string;
                                        isExclusive: boolean;
                                        isFree: boolean;
                                        name?: string | undefined;
                                        packState: PackState;
                                        slug?: string | undefined;
                                        type: PackType;
                                        artist?:
                                            | {
                                                  __typename?: 'Artist';
                                                  guid: string;
                                                  slug?: string | undefined;
                                                  name?: string | undefined;
                                                  isExclusive: boolean;
                                              }
                                            | undefined;
                                        label?:
                                            | {
                                                  __typename?: 'Label';
                                                  guid: string;
                                                  name?: string | undefined;
                                                  slug?: string | undefined;
                                                  isExclusive: boolean;
                                              }
                                            | undefined;
                                    }
                                  | undefined;
                              classifiers: Array<{
                                  __typename?: 'Classifier';
                                  id: string;
                                  code: string;
                                  type: ClassifierType;
                                  isPackClassifier: boolean;
                              }>;
                          }
                        | undefined
                    >
                  | undefined;
              meta?:
                  | {
                        __typename?: 'MetaPage';
                        totalRecords?: number | undefined;
                        totalSampleRecords?: number | undefined;
                        totalPackRecords?: number | undefined;
                        filters?:
                            | {
                                  __typename?: 'Filters';
                                  sampleTypeFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                                  instrumentFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                                  genreFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                                  sfxFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                                  tagFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                              }
                            | undefined;
                    }
                  | undefined;
              next?:
                  | { __typename?: 'NextPage'; skip?: number | undefined }
                  | undefined;
          }
        | undefined;
};

export type UpdateRepackFavoritedStateMutationVariables = Exact<{
    repack: RepackFavoritedInput;
}>;

export type UpdateRepackFavoritedStateMutation = {
    __typename?: 'Mutation';
    updateRepackFavoritedState?:
        | {
              __typename?: 'Repack';
              guid: string;
              isFavorited?: boolean | undefined;
          }
        | undefined;
};

export type RepacksStreamQueryVariables = Exact<{
    repackGuid: Scalars['ID']['input'];
}>;

export type RepacksStreamQuery = {
    __typename?: 'Query';
    repackStream?:
        | { __typename?: 'StreamUrl'; url?: string | undefined }
        | undefined;
};

export type SampleKeyFragmentFragment = {
    __typename?: 'SampleKey';
    code?: string | undefined;
    root?: KeyRootApi | undefined;
    quality?: KeyQuality | undefined;
};

export type ClassifierFragmentFragment = {
    __typename?: 'Classifier';
    id: string;
    code: string;
    type: ClassifierType;
    isPackClassifier: boolean;
};

export type SampleFragmentFragment = {
    __typename?: 'Sample';
    guid: string;
    name?: string | undefined;
    bpm?: number | undefined;
    credits?: number | undefined;
    duration?: number | undefined;
    isDownloaded: boolean;
    isFavorited: boolean;
    isRecommendationFiller?: boolean | undefined;
    sampleState: SampleState;
    sampleType?: SampleType | undefined;
    waveformUrl?: string | undefined;
    key?:
        | {
              __typename?: 'SampleKey';
              code?: string | undefined;
              root?: KeyRootApi | undefined;
              quality?: KeyQuality | undefined;
          }
        | undefined;
    pack?:
        | {
              __typename?: 'Pack';
              artworkUrl?: string | undefined;
              guid: string;
              isExclusive: boolean;
              isFree: boolean;
              name?: string | undefined;
              packState: PackState;
              slug?: string | undefined;
              type: PackType;
              artist?:
                  | {
                        __typename?: 'Artist';
                        guid: string;
                        slug?: string | undefined;
                        name?: string | undefined;
                        isExclusive: boolean;
                    }
                  | undefined;
              label?:
                  | {
                        __typename?: 'Label';
                        guid: string;
                        name?: string | undefined;
                        slug?: string | undefined;
                        isExclusive: boolean;
                    }
                  | undefined;
          }
        | undefined;
    classifiers: Array<{
        __typename?: 'Classifier';
        id: string;
        code: string;
        type: ClassifierType;
        isPackClassifier: boolean;
    }>;
};

export type SampleQueryVariables = Exact<{
    sampleGuid: Scalars['ID']['input'];
}>;

export type SampleQuery = {
    __typename?: 'Query';
    sample?:
        | {
              __typename?: 'Sample';
              guid: string;
              name?: string | undefined;
              bpm?: number | undefined;
              credits?: number | undefined;
              duration?: number | undefined;
              isDownloaded: boolean;
              isFavorited: boolean;
              isRecommendationFiller?: boolean | undefined;
              sampleState: SampleState;
              sampleType?: SampleType | undefined;
              waveformUrl?: string | undefined;
              key?:
                  | {
                        __typename?: 'SampleKey';
                        code?: string | undefined;
                        root?: KeyRootApi | undefined;
                        quality?: KeyQuality | undefined;
                    }
                  | undefined;
              pack?:
                  | {
                        __typename?: 'Pack';
                        artworkUrl?: string | undefined;
                        guid: string;
                        isExclusive: boolean;
                        isFree: boolean;
                        name?: string | undefined;
                        packState: PackState;
                        slug?: string | undefined;
                        type: PackType;
                        artist?:
                            | {
                                  __typename?: 'Artist';
                                  guid: string;
                                  slug?: string | undefined;
                                  name?: string | undefined;
                                  isExclusive: boolean;
                              }
                            | undefined;
                        label?:
                            | {
                                  __typename?: 'Label';
                                  guid: string;
                                  name?: string | undefined;
                                  slug?: string | undefined;
                                  isExclusive: boolean;
                              }
                            | undefined;
                    }
                  | undefined;
              classifiers: Array<{
                  __typename?: 'Classifier';
                  id: string;
                  code: string;
                  type: ClassifierType;
                  isPackClassifier: boolean;
              }>;
          }
        | undefined;
};

export type SampleIsDownloadedQueryVariables = Exact<{
    guid: Scalars['ID']['input'];
}>;

export type SampleIsDownloadedQuery = {
    __typename?: 'Query';
    sample?:
        | { __typename?: 'Sample'; guid: string; isDownloaded: boolean }
        | undefined;
};

export type PaginatedSamplesQueryVariables = Exact<{
    take?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    query?: InputMaybe<Scalars['String']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
}>;

export type PaginatedSamplesQuery = {
    __typename?: 'Query';
    paginatedSamples?:
        | {
              __typename?: 'PaginatedSamples';
              data?:
                  | Array<
                        | {
                              __typename?: 'Sample';
                              guid: string;
                              name?: string | undefined;
                              bpm?: number | undefined;
                              credits?: number | undefined;
                              duration?: number | undefined;
                              isDownloaded: boolean;
                              isFavorited: boolean;
                              isRecommendationFiller?: boolean | undefined;
                              sampleState: SampleState;
                              sampleType?: SampleType | undefined;
                              waveformUrl?: string | undefined;
                              key?:
                                  | {
                                        __typename?: 'SampleKey';
                                        code?: string | undefined;
                                        root?: KeyRootApi | undefined;
                                        quality?: KeyQuality | undefined;
                                    }
                                  | undefined;
                              pack?:
                                  | {
                                        __typename?: 'Pack';
                                        artworkUrl?: string | undefined;
                                        guid: string;
                                        isExclusive: boolean;
                                        isFree: boolean;
                                        name?: string | undefined;
                                        packState: PackState;
                                        slug?: string | undefined;
                                        type: PackType;
                                        artist?:
                                            | {
                                                  __typename?: 'Artist';
                                                  guid: string;
                                                  slug?: string | undefined;
                                                  name?: string | undefined;
                                                  isExclusive: boolean;
                                              }
                                            | undefined;
                                        label?:
                                            | {
                                                  __typename?: 'Label';
                                                  guid: string;
                                                  name?: string | undefined;
                                                  slug?: string | undefined;
                                                  isExclusive: boolean;
                                              }
                                            | undefined;
                                    }
                                  | undefined;
                              classifiers: Array<{
                                  __typename?: 'Classifier';
                                  id: string;
                                  code: string;
                                  type: ClassifierType;
                                  isPackClassifier: boolean;
                              }>;
                          }
                        | undefined
                    >
                  | undefined;
              meta?:
                  | {
                        __typename?: 'MetaPage';
                        totalRecords?: number | undefined;
                        totalSampleRecords?: number | undefined;
                        totalPackRecords?: number | undefined;
                        filters?:
                            | {
                                  __typename?: 'Filters';
                                  sampleTypeFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                                  instrumentFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                                  genreFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                                  sfxFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                                  tagFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                              }
                            | undefined;
                    }
                  | undefined;
              next?:
                  | { __typename?: 'NextPage'; skip?: number | undefined }
                  | undefined;
          }
        | undefined;
};

export type PaginatedDownloadedSamplesQueryVariables = Exact<{
    take?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    query?: InputMaybe<Scalars['String']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
}>;

export type PaginatedDownloadedSamplesQuery = {
    __typename?: 'Query';
    paginatedDownloadedSamples?:
        | {
              __typename?: 'PaginatedSamples';
              data?:
                  | Array<
                        | {
                              __typename?: 'Sample';
                              guid: string;
                              name?: string | undefined;
                              bpm?: number | undefined;
                              credits?: number | undefined;
                              duration?: number | undefined;
                              isDownloaded: boolean;
                              isFavorited: boolean;
                              isRecommendationFiller?: boolean | undefined;
                              sampleState: SampleState;
                              sampleType?: SampleType | undefined;
                              waveformUrl?: string | undefined;
                              key?:
                                  | {
                                        __typename?: 'SampleKey';
                                        code?: string | undefined;
                                        root?: KeyRootApi | undefined;
                                        quality?: KeyQuality | undefined;
                                    }
                                  | undefined;
                              pack?:
                                  | {
                                        __typename?: 'Pack';
                                        artworkUrl?: string | undefined;
                                        guid: string;
                                        isExclusive: boolean;
                                        isFree: boolean;
                                        name?: string | undefined;
                                        packState: PackState;
                                        slug?: string | undefined;
                                        type: PackType;
                                        artist?:
                                            | {
                                                  __typename?: 'Artist';
                                                  guid: string;
                                                  slug?: string | undefined;
                                                  name?: string | undefined;
                                                  isExclusive: boolean;
                                              }
                                            | undefined;
                                        label?:
                                            | {
                                                  __typename?: 'Label';
                                                  guid: string;
                                                  name?: string | undefined;
                                                  slug?: string | undefined;
                                                  isExclusive: boolean;
                                              }
                                            | undefined;
                                    }
                                  | undefined;
                              classifiers: Array<{
                                  __typename?: 'Classifier';
                                  id: string;
                                  code: string;
                                  type: ClassifierType;
                                  isPackClassifier: boolean;
                              }>;
                          }
                        | undefined
                    >
                  | undefined;
              meta?:
                  | {
                        __typename?: 'MetaPage';
                        totalRecords?: number | undefined;
                        totalSampleRecords?: number | undefined;
                        totalPackRecords?: number | undefined;
                        filters?:
                            | {
                                  __typename?: 'Filters';
                                  sampleTypeFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                                  instrumentFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                                  genreFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                                  sfxFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                                  tagFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                              }
                            | undefined;
                    }
                  | undefined;
              next?:
                  | { __typename?: 'NextPage'; skip?: number | undefined }
                  | undefined;
          }
        | undefined;
};

export type PaginatedFavoritedSamplesQueryVariables = Exact<{
    take?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    query?: InputMaybe<Scalars['String']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
}>;

export type PaginatedFavoritedSamplesQuery = {
    __typename?: 'Query';
    paginatedFavoritedSamples?:
        | {
              __typename?: 'PaginatedSamples';
              data?:
                  | Array<
                        | {
                              __typename?: 'Sample';
                              guid: string;
                              name?: string | undefined;
                              bpm?: number | undefined;
                              credits?: number | undefined;
                              duration?: number | undefined;
                              isDownloaded: boolean;
                              isFavorited: boolean;
                              isRecommendationFiller?: boolean | undefined;
                              sampleState: SampleState;
                              sampleType?: SampleType | undefined;
                              waveformUrl?: string | undefined;
                              key?:
                                  | {
                                        __typename?: 'SampleKey';
                                        code?: string | undefined;
                                        root?: KeyRootApi | undefined;
                                        quality?: KeyQuality | undefined;
                                    }
                                  | undefined;
                              pack?:
                                  | {
                                        __typename?: 'Pack';
                                        artworkUrl?: string | undefined;
                                        guid: string;
                                        isExclusive: boolean;
                                        isFree: boolean;
                                        name?: string | undefined;
                                        packState: PackState;
                                        slug?: string | undefined;
                                        type: PackType;
                                        artist?:
                                            | {
                                                  __typename?: 'Artist';
                                                  guid: string;
                                                  slug?: string | undefined;
                                                  name?: string | undefined;
                                                  isExclusive: boolean;
                                              }
                                            | undefined;
                                        label?:
                                            | {
                                                  __typename?: 'Label';
                                                  guid: string;
                                                  name?: string | undefined;
                                                  slug?: string | undefined;
                                                  isExclusive: boolean;
                                              }
                                            | undefined;
                                    }
                                  | undefined;
                              classifiers: Array<{
                                  __typename?: 'Classifier';
                                  id: string;
                                  code: string;
                                  type: ClassifierType;
                                  isPackClassifier: boolean;
                              }>;
                          }
                        | undefined
                    >
                  | undefined;
              meta?:
                  | {
                        __typename?: 'MetaPage';
                        totalRecords?: number | undefined;
                        totalSampleRecords?: number | undefined;
                        totalPackRecords?: number | undefined;
                        filters?:
                            | {
                                  __typename?: 'Filters';
                                  sampleTypeFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                                  instrumentFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                                  genreFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                                  sfxFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                                  tagFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                              }
                            | undefined;
                    }
                  | undefined;
              next?:
                  | { __typename?: 'NextPage'; skip?: number | undefined }
                  | undefined;
          }
        | undefined;
};

export type PaginatedRecommendedSamplesQueryVariables = Exact<{
    sampleGuid: Scalars['ID']['input'];
    take?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    query?: InputMaybe<Scalars['String']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
}>;

export type PaginatedRecommendedSamplesQuery = {
    __typename?: 'Query';
    paginatedRecommendedSamples?:
        | {
              __typename?: 'PaginatedSamples';
              data?:
                  | Array<
                        | {
                              __typename?: 'Sample';
                              guid: string;
                              name?: string | undefined;
                              bpm?: number | undefined;
                              credits?: number | undefined;
                              duration?: number | undefined;
                              isDownloaded: boolean;
                              isFavorited: boolean;
                              isRecommendationFiller?: boolean | undefined;
                              sampleState: SampleState;
                              sampleType?: SampleType | undefined;
                              waveformUrl?: string | undefined;
                              key?:
                                  | {
                                        __typename?: 'SampleKey';
                                        code?: string | undefined;
                                        root?: KeyRootApi | undefined;
                                        quality?: KeyQuality | undefined;
                                    }
                                  | undefined;
                              pack?:
                                  | {
                                        __typename?: 'Pack';
                                        artworkUrl?: string | undefined;
                                        guid: string;
                                        isExclusive: boolean;
                                        isFree: boolean;
                                        name?: string | undefined;
                                        packState: PackState;
                                        slug?: string | undefined;
                                        type: PackType;
                                        artist?:
                                            | {
                                                  __typename?: 'Artist';
                                                  guid: string;
                                                  slug?: string | undefined;
                                                  name?: string | undefined;
                                                  isExclusive: boolean;
                                              }
                                            | undefined;
                                        label?:
                                            | {
                                                  __typename?: 'Label';
                                                  guid: string;
                                                  name?: string | undefined;
                                                  slug?: string | undefined;
                                                  isExclusive: boolean;
                                              }
                                            | undefined;
                                    }
                                  | undefined;
                              classifiers: Array<{
                                  __typename?: 'Classifier';
                                  id: string;
                                  code: string;
                                  type: ClassifierType;
                                  isPackClassifier: boolean;
                              }>;
                          }
                        | undefined
                    >
                  | undefined;
              meta?:
                  | {
                        __typename?: 'MetaPage';
                        totalRecords?: number | undefined;
                        totalSampleRecords?: number | undefined;
                        totalPackRecords?: number | undefined;
                        filters?:
                            | {
                                  __typename?: 'Filters';
                                  sampleTypeFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                                  instrumentFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                                  genreFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                                  sfxFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                                  tagFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                              }
                            | undefined;
                    }
                  | undefined;
              next?:
                  | { __typename?: 'NextPage'; skip?: number | undefined }
                  | undefined;
          }
        | undefined;
};

export type UpdateSampleFavoritedStateMutationVariables = Exact<{
    sample: SampleFavoritedInput;
}>;

export type UpdateSampleFavoritedStateMutation = {
    __typename?: 'Mutation';
    updateSampleFavoritedState?:
        | { __typename?: 'Sample'; guid: string; isFavorited: boolean }
        | undefined;
};

export type SampleStreamQueryVariables = Exact<{
    sampleGuid: Scalars['ID']['input'];
}>;

export type SampleStreamQuery = {
    __typename?: 'Query';
    sampleStream?:
        | { __typename?: 'StreamUrl'; url?: string | undefined }
        | undefined;
};

export type GetSeoByPathQueryVariables = Exact<{
    pathname?: InputMaybe<Scalars['ID']['input']>;
}>;

export type GetSeoByPathQuery = {
    __typename?: 'Query';
    seoByPath?:
        | {
              __typename?: 'Seo';
              title?: string | undefined;
              description?: string | undefined;
              header?: string | undefined;
              byline?: string | undefined;
          }
        | undefined;
};

export type UserProfileQueryVariables = Exact<{ [key: string]: never }>;

export type UserProfileQuery = {
    __typename?: 'Query';
    userProfile?:
        | {
              __typename?: 'User';
              userId: string;
              email?: string | undefined;
              firstname?: string | undefined;
              lastname?: string | undefined;
              profilePicture72Url?: string | undefined;
              country?: string | undefined;
          }
        | undefined;
};

export type UserCreditsQueryVariables = Exact<{ [key: string]: never }>;

export type UserCreditsQuery = {
    __typename?: 'Query';
    userCredits?:
        | { __typename?: 'UserCredits'; remaining?: number | undefined }
        | undefined;
};

export type UserAgreementsQueryVariables = Exact<{ [key: string]: never }>;

export type UserAgreementsQuery = {
    __typename?: 'Query';
    userAgreements?:
        | {
              __typename?: 'Agreements';
              agreements?:
                  | Array<
                        | {
                              __typename?: 'Agreement';
                              requireUpdate?: boolean | undefined;
                              kind: LegalAgreementKindEnum;
                              version?: string | undefined;
                          }
                        | undefined
                    >
                  | undefined;
          }
        | undefined;
};

export type AccountBalanceSummaryQueryVariables = Exact<{
    [key: string]: never;
}>;

export type AccountBalanceSummaryQuery = {
    __typename?: 'Query';
    accountBalanceSummary?:
        | {
              __typename?: 'AccountBalanceSummary';
              accountingStatus: AccountStatusEnum;
          }
        | undefined;
};

export type SubscriptionsAndAllowedFeaturesQueryVariables = Exact<{
    [key: string]: never;
}>;

export type SubscriptionsAndAllowedFeaturesQuery = {
    __typename?: 'Query';
    subscriptionsAndAllowedFeatures?:
        | {
              __typename?: 'SubscriptionsAndAllowedFeatures';
              hasStudioPlan: boolean;
              hasSamplesPlan: boolean;
              hasSubscription: boolean;
              upsellingAllowed: boolean;
              samplePaidContentAccess: {
                  __typename?: 'AllowedFeature';
                  isAllowed: boolean;
                  unallowedReason?:
                      | {
                            __typename?: 'UnallowedReason';
                            reason: string;
                            unallowedByPlan?: string | undefined;
                        }
                      | undefined;
              };
              subscriptionsDetails: Array<{
                  __typename?: 'SubscriptionDetails';
                  status: SubscriptionDetailsStatus;
                  isTrialingSubscription: boolean;
                  isYearly: boolean;
                  serviceOffer: ServiceOfferKind;
                  current: {
                      __typename?: 'CurrentSubscriptionDetails';
                      code: string;
                      renewalDate?: any | undefined;
                      endDate?: any | undefined;
                      nextPaymentAmount: {
                          __typename?: 'Price';
                          value?: number | undefined;
                          currency: {
                              __typename?: 'Currency';
                              currencyCode: string;
                              currencySymbol: string;
                          };
                      };
                  };
              }>;
          }
        | undefined;
};

export type AcceptUserAgreementsMutationVariables = Exact<{
    agreements: AcceptUserAgreementsInput;
}>;

export type AcceptUserAgreementsMutation = {
    __typename?: 'Mutation';
    acceptUserAgreements?: boolean | undefined;
};

export type ActivateTrialSubscriptionMutationVariables = Exact<{
    [key: string]: never;
}>;

export type ActivateTrialSubscriptionMutation = {
    __typename?: 'Mutation';
    activateTrialSubscription: {
        __typename?: 'SubscriptionsAndAllowedFeatures';
        samplePaidContentAccess: {
            __typename?: 'AllowedFeature';
            isAllowed: boolean;
            unallowedReason?:
                | {
                      __typename?: 'UnallowedReason';
                      reason: string;
                      unallowedByPlan?: string | undefined;
                  }
                | undefined;
        };
    };
};

export type UserCollectionFragmentFragment = {
    __typename?: 'UserCollection';
    artworkUrl?: string | undefined;
    guid?: string | undefined;
    name?: string | undefined;
    sampleCount?: number | undefined;
    userId?: string | undefined;
};

export type UserCollectionQueryVariables = Exact<{
    collectionGuid?: InputMaybe<Scalars['ID']['input']>;
}>;

export type UserCollectionQuery = {
    __typename?: 'Query';
    userCollection?:
        | {
              __typename?: 'UserCollection';
              artworkUrl?: string | undefined;
              guid?: string | undefined;
              name?: string | undefined;
              sampleCount?: number | undefined;
              userId?: string | undefined;
          }
        | undefined;
};

export type DeleteUserCollectionMutationVariables = Exact<{
    collectionGuid?: InputMaybe<Scalars['ID']['input']>;
}>;

export type DeleteUserCollectionMutation = {
    __typename?: 'Mutation';
    deleteUserCollection?: string | undefined;
};

export type UserCollectionsFeedQueryVariables = Exact<{
    take?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    query?: InputMaybe<Scalars['String']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
}>;

export type UserCollectionsFeedQuery = {
    __typename?: 'Query';
    userCollectionsFeed?:
        | {
              __typename?: 'UserCollectionsFeed';
              feed?:
                  | Array<
                        | {
                              __typename?: 'UserCollection';
                              artworkUrl?: string | undefined;
                              guid?: string | undefined;
                              name?: string | undefined;
                              sampleCount?: number | undefined;
                              userId?: string | undefined;
                          }
                        | undefined
                    >
                  | undefined;
              meta?:
                  | {
                        __typename?: 'MetaPage';
                        totalRecords?: number | undefined;
                        totalSampleRecords?: number | undefined;
                        totalPackRecords?: number | undefined;
                        filters?:
                            | {
                                  __typename?: 'Filters';
                                  sampleTypeFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                                  instrumentFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                                  genreFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                                  sfxFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                                  tagFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                              }
                            | undefined;
                    }
                  | undefined;
          }
        | undefined;
};

export type PaginatedUserCollectionsQueryVariables = Exact<{
    take?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    query?: InputMaybe<Scalars['String']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
}>;

export type PaginatedUserCollectionsQuery = {
    __typename?: 'Query';
    paginatedUserCollections?:
        | {
              __typename?: 'PaginatedUserCollections';
              data?:
                  | Array<
                        | {
                              __typename?: 'UserCollection';
                              artworkUrl?: string | undefined;
                              guid?: string | undefined;
                              name?: string | undefined;
                              sampleCount?: number | undefined;
                              userId?: string | undefined;
                          }
                        | undefined
                    >
                  | undefined;
              meta?:
                  | {
                        __typename?: 'MetaPage';
                        totalRecords?: number | undefined;
                        totalSampleRecords?: number | undefined;
                        totalPackRecords?: number | undefined;
                        filters?:
                            | {
                                  __typename?: 'Filters';
                                  sampleTypeFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                                  instrumentFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                                  genreFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                                  sfxFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                                  tagFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                              }
                            | undefined;
                    }
                  | undefined;
          }
        | undefined;
};

export type PaginatedUserCollectionSamplesQueryVariables = Exact<{
    collectionGuid?: InputMaybe<Scalars['ID']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    query?: InputMaybe<Scalars['String']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
}>;

export type PaginatedUserCollectionSamplesQuery = {
    __typename?: 'Query';
    paginatedUserCollectionSamples?:
        | {
              __typename?: 'PaginatedSamples';
              data?:
                  | Array<
                        | {
                              __typename?: 'Sample';
                              guid: string;
                              name?: string | undefined;
                              bpm?: number | undefined;
                              credits?: number | undefined;
                              duration?: number | undefined;
                              isDownloaded: boolean;
                              isFavorited: boolean;
                              isRecommendationFiller?: boolean | undefined;
                              sampleState: SampleState;
                              sampleType?: SampleType | undefined;
                              waveformUrl?: string | undefined;
                              key?:
                                  | {
                                        __typename?: 'SampleKey';
                                        code?: string | undefined;
                                        root?: KeyRootApi | undefined;
                                        quality?: KeyQuality | undefined;
                                    }
                                  | undefined;
                              pack?:
                                  | {
                                        __typename?: 'Pack';
                                        artworkUrl?: string | undefined;
                                        guid: string;
                                        isExclusive: boolean;
                                        isFree: boolean;
                                        name?: string | undefined;
                                        packState: PackState;
                                        slug?: string | undefined;
                                        type: PackType;
                                        artist?:
                                            | {
                                                  __typename?: 'Artist';
                                                  guid: string;
                                                  slug?: string | undefined;
                                                  name?: string | undefined;
                                                  isExclusive: boolean;
                                              }
                                            | undefined;
                                        label?:
                                            | {
                                                  __typename?: 'Label';
                                                  guid: string;
                                                  name?: string | undefined;
                                                  slug?: string | undefined;
                                                  isExclusive: boolean;
                                              }
                                            | undefined;
                                    }
                                  | undefined;
                              classifiers: Array<{
                                  __typename?: 'Classifier';
                                  id: string;
                                  code: string;
                                  type: ClassifierType;
                                  isPackClassifier: boolean;
                              }>;
                          }
                        | undefined
                    >
                  | undefined;
              meta?:
                  | {
                        __typename?: 'MetaPage';
                        totalRecords?: number | undefined;
                        totalSampleRecords?: number | undefined;
                        totalPackRecords?: number | undefined;
                        filters?:
                            | {
                                  __typename?: 'Filters';
                                  sampleTypeFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                                  instrumentFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                                  genreFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                                  sfxFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                                  tagFilters?:
                                      | Array<
                                            | {
                                                  __typename?: 'FilterMeta';
                                                  name?: string | undefined;
                                                  value?: number | undefined;
                                              }
                                            | undefined
                                        >
                                      | undefined;
                              }
                            | undefined;
                    }
                  | undefined;
              next?:
                  | { __typename?: 'NextPage'; skip?: number | undefined }
                  | undefined;
          }
        | undefined;
};

export type EditUserCollectionMutationVariables = Exact<{
    collectionGuid?: InputMaybe<Scalars['ID']['input']>;
    name?: InputMaybe<Scalars['String']['input']>;
}>;

export type EditUserCollectionMutation = {
    __typename?: 'Mutation';
    editUserCollection?: string | undefined;
};

export type CreateUserCollectionMutationVariables = Exact<{
    name?: InputMaybe<Scalars['String']['input']>;
    sampleCount?: InputMaybe<Scalars['Int']['input']>;
}>;

export type CreateUserCollectionMutation = {
    __typename?: 'Mutation';
    createUserCollection?:
        | {
              __typename?: 'UserCollection';
              guid?: string | undefined;
              name?: string | undefined;
          }
        | undefined;
};

export type AddSamplesToUserCollectionMutationVariables = Exact<{
    sampleIds?: InputMaybe<
        | Array<InputMaybe<Scalars['ID']['input']>>
        | InputMaybe<Scalars['ID']['input']>
    >;
    collectionGuid?: InputMaybe<Scalars['ID']['input']>;
}>;

export type AddSamplesToUserCollectionMutation = {
    __typename?: 'Mutation';
    addSamplesToUserCollection?:
        | { __typename?: 'UserCollection'; guid?: string | undefined }
        | undefined;
};

export type RemoveSamplesFromUserCollectionMutationVariables = Exact<{
    sampleIds?: InputMaybe<
        | Array<InputMaybe<Scalars['ID']['input']>>
        | InputMaybe<Scalars['ID']['input']>
    >;
    collectionGuid?: InputMaybe<Scalars['ID']['input']>;
}>;

export type RemoveSamplesFromUserCollectionMutation = {
    __typename?: 'Mutation';
    removeSamplesFromUserCollection?:
        | { __typename?: 'UserCollection'; guid?: string | undefined }
        | undefined;
};

export type CreateUserRecentSearchMutationVariables = Exact<{
    filterType: UserSearchFilter;
    filterSlug: Scalars['String']['input'];
}>;

export type CreateUserRecentSearchMutation = {
    __typename?: 'Mutation';
    createUserRecentSearch?: string | undefined;
};

export type GetUserRecentSearchQueryVariables = Exact<{ [key: string]: never }>;

export type GetUserRecentSearchQuery = {
    __typename?: 'Query';
    getUserRecentSearch: {
        __typename?: 'UserRecentSearches';
        recentSearch: Array<{
            __typename?: 'UserRecentSearch';
            searchFilter: UserSearchFilter;
            filterSlug: string;
        }>;
    };
};

export type DeleteUserRecentSearchMutationVariables = Exact<{
    filterType: UserSearchFilter;
    filterSlug: Scalars['String']['input'];
}>;

export type DeleteUserRecentSearchMutation = {
    __typename?: 'Mutation';
    deleteUserRecentSearch?: string | undefined;
};

export type SampleFromGuidFragment = {
    __typename?: 'Sample';
    guid: string;
    name?: string | undefined;
};
